<template>
  <div class="content mt-n10" @contextmenu.prevent>
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-50">
        <v-card
          tile
          elevation="0"
          class="ma-0 pa-0"
          :style="{
            background: $vuetify.theme.themes[theme].background,
          }"
        >
          <!-- row 1 -->
          <v-row class="mt-7">
            <v-col cols="1" class="ml-n2 mt-2">
              <v-icon @click="toggleSidebar()"> mdi-dots-vertical </v-icon>
            </v-col>
            <v-col cols="5" class="ml-n3 mt-n7">
              <div style="display: flex">
                <h2
                  style="
                    opacity: 0.8;
                    font-family: Nunito Sans;
                    font-size: 2rem !important;
                    font-weight: 1000 !important;
                  "
                >
                  {{ file.filename }}
                </h2>
                <p class="mt-10 ml-2">(V{{ formatVersion(file.version) }})</p>
              </div>
            </v-col>
            <v-col cols="1" class="mt-2">
              <v-menu rounded="lg" offset-y bottom max-width="150">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">mdi-delete-outline </v-icon>
                </template>
                <v-card
                  elevation="0"
                  width="150"
                  height="100"
                  :style="{
                    background: $vuetify.theme.themes[theme].background,
                  }"
                >
                  <div class="ma-0 pa-0" style="text-align: center">
                    <v-btn
                      width="120"
                      @click="deleteSingleFile(file.id)"
                      text
                      outlined
                    >
                      Single
                    </v-btn>
                  </div>

                  <div class="ma-0 pa-0 mt-3" style="text-align: center">
                    <v-btn
                      width="120"
                      @click="deleteFiles(fileItems)"
                      text
                      outlined
                      >Delete All</v-btn
                    >
                  </div>
                </v-card>
              </v-menu>
            </v-col>
            <v-col cols="1" class="mt-2">
              <v-icon>mdi-pencil-outline</v-icon>
            </v-col>
            <v-col cols="1" class="mt-n3">
              <v-checkbox> </v-checkbox>
            </v-col>
            <v-col cols="3" class="mt-3">
              <p style="font-size: 12px">File name</p>
            </v-col>
          </v-row>
          <div
            class="ma-0 pa-0"
            style="text-align: right"
            v-if="augmentableTheme"
          >
            <v-btn icon @click="goToViewerWithFile()"
              ><md-icon
                class="md-size-1x"
                md-src="/static/assets/svg/white/Viewer.svg"
              ></md-icon
            ></v-btn>
            <v-btn icon @click="goToEditorWithFile()"
              ><md-icon
                class="md-size-1x"
                md-src="/static/assets/svg/white/CAD.svg"
              ></md-icon
            ></v-btn>
          </div>
          <div
            class="ma-0 pa-0"
            style="text-align: right"
            v-if="!augmentableTheme"
          >
            <v-btn icon @click="goToViewerWithFile()"
              ><md-icon
                class="md-size-1x"
                md-src="/static/assets/svg/black/Viewer.svg"
              ></md-icon
            ></v-btn>
            <v-btn icon @click="goToEditorWithFile()"
              ><md-icon
                class="md-size-1x"
                md-src="/static/assets/svg/black/CAD.svg"
              ></md-icon
            ></v-btn>
          </div>
          <v-divider class="mx-2" style="border-color: #d3d3d3"></v-divider>
          <!-- cardtext 1 -->
          <v-card-text class="mt-n3 ml-1">
            <v-row class="">
              <p style="font-weight: 800; opacity: 0.8">
                Description
                <v-icon
                  style="cursor: pointer"
                  @click="description = !description"
                  v-if="!description"
                  >mdi-menu-right</v-icon
                >
                <v-icon
                  style="cursor: pointer"
                  @click="description = !description"
                  v-if="description"
                  >mdi-menu-down</v-icon
                ><v-icon v-if="!file.description" @click="editDescription()"
                  >mdi-plus</v-icon
                >
                <v-icon
                  v-if="file.description"
                  size="18"
                  @click="editDescription()"
                  >mdi-pencil-outline</v-icon
                >
              </p>
            </v-row>

            <v-row justify="start" class="mt-n4" v-if="description">
              <v-col cols="1"></v-col>
              <v-col cols="6">
                <v-textarea
                  v-if="descriptionEdit"
                  style="border-radius: 12px"
                  v-model="file.description"
                  filled
                  auto-grow
                  rows="1"
                  row-height="15"
                  rounded
                  @keydown.enter.exact.prevent
                  @keyup.enter.exact="updateDescription()"
                  @keydown.enter.shift.exact="newlineDescription()"
                ></v-textarea>
                <v-card-subtitle v-else class="mt-n2">{{
                  file.description
                }}</v-card-subtitle>
              </v-col>
              <v-col></v-col>
            </v-row>
          </v-card-text>
          <v-divider
            class="mx-2 mt-n5"
            style="border-color: #d3d3d3"
          ></v-divider>
          <!-- cardtext 2 -->
          <v-card-text class="mt-n3 ml-1">
            <v-row class="">
              <p style="font-weight: 800; opacity: 0.8">
                Progress
                <v-icon
                  style="cursor: pointer"
                  @click="progress = !progress"
                  v-if="!progress"
                  >mdi-menu-right
                </v-icon>
                <v-icon
                  style="cursor: pointer"
                  @click="progress = !progress"
                  v-if="progress"
                  >mdi-menu-down
                </v-icon>
                <v-icon>mdi-plus</v-icon>
              </p>
            </v-row>
            <v-row justify="start" v-if="progress">
              <v-col cols="1"></v-col>
              <v-col>
                <div style="display: flex" class="ma-0 pa-0 mt-2">
                  <div v-for="(item, index) in localitem" :key="index">
                    <v-row class="ma-0 pa-0" justify="center" align="center">
                      <show-at breakpoint="mediumAndBelow">
                        <div class="ma-0 pa-0">
                          <v-banner
                            v-if="item.progressbanner"
                            :dark="lightTheme"
                            :light="darkTheme"
                            color="grey"
                            width="35"
                            height="1"
                          ></v-banner>
                        </div>
                      </show-at>
                      <hide-at breakpoint="mediumAndBelow">
                        <div class="ma-0 pa-0">
                          <v-banner
                            v-if="item.progressbanner"
                            :dark="lightTheme"
                            :light="darkTheme"
                            color="grey"
                            width="30"
                            height="1"
                          ></v-banner>
                        </div>
                      </hide-at>
                      <v-icon v-if="item.progressicon" size="20" color="grey">
                        mdi-circle-outline</v-icon
                      >
                      <v-banner
                        v-if="item.progressbanner"
                        :dark="lightTheme"
                        :light="darkTheme"
                        color="grey"
                        width="30"
                        height="1"
                      ></v-banner>
                    </v-row>
                    <v-row justify="center" align="center">
                      <p
                        v-if="item.progressheadingcheck"
                        style="
                          font-size: 9px;
                          font-weight: 600;
                          text-align: center;
                        "
                      >
                        {{ item.progressheading }}
                      </p>
                    </v-row>
                    <v-row justify="center" align="center">
                      <p
                        style="
                          font-size: 8px;
                          font-weight: 600;
                          text-align: center;
                        "
                        v-if="item.datecheck"
                      >
                        {{ item.date }}
                      </p>
                    </v-row>
                  </div>

                  <show-at breakpoint="mediumAndBelow">
                    <div class="ma-0 pa-0">
                      <v-banner
                        :dark="lightTheme"
                        :light="darkTheme"
                        color="grey"
                        width="35"
                        style="margin-top: 0.7em"
                        height="1"
                      ></v-banner>
                    </div>
                  </show-at>
                  <hide-at breakpoint="mediumAndBelow">
                    <div class="ma-0 pa-0">
                      <v-banner
                        :dark="lightTheme"
                        :light="darkTheme"
                        color="grey"
                        width="65"
                        style="margin-top: 0.7em"
                        height="1"
                      ></v-banner>
                    </div>
                  </hide-at>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider
            class="mx-2 mt-n5"
            style="border-color: #d3d3d3"
          ></v-divider>
          <!-- cardtext3 -->
          <v-card-text class="mt-n3 ml-1">
            <v-row class="">
              <p style="font-weight: 800; opacity: 0.8">
                Status
                <v-icon
                  style="cursor: pointer"
                  @click="status = !status"
                  v-if="!status"
                  >mdi-menu-right
                </v-icon>
                <v-icon
                  style="cursor: pointer"
                  @click="status = !status"
                  v-if="status"
                  >mdi-menu-down
                </v-icon>
              </p>
            </v-row>
            <v-row class="mt-n3" v-if="status">
              <v-col cols="1"></v-col>
              <v-col>
                <div style="display: flex" class="ma-0 pa-0 mt-2">
                  <div v-for="(item, index) in localStatus" :key="index">
                    <v-row class="ma-0 pa-0" justify="center">
                      <show-at breakpoint="mediumAndBelow">
                        <div class="ma-0 pa-0">
                          <v-banner
                            :dark="lightTheme"
                            :light="darkTheme"
                            class="mt-3"
                            color="grey"
                            width="50"
                            height="1"
                          ></v-banner>
                        </div>
                      </show-at>
                      <hide-at breakpoint="mediumAndBelow">
                        <div class="ma-0 pa-0">
                          <v-banner
                            :dark="lightTheme"
                            :light="darkTheme"
                            class="mt-3"
                            color="grey"
                            width="50"
                            height="1"
                          ></v-banner>
                        </div>
                      </hide-at>
                      <v-icon
                        class=""
                        size="24"
                        color="grey"
                        @click="changeStatus(item)"
                      >
                        mdi-circle-outline</v-icon
                      >
                      <v-icon
                        v-if="item.value"
                        class="ml-n6"
                        size="24"
                        color="blue"
                      >
                        mdi-circle-medium</v-icon
                      >

                      <show-at breakpoint="mediumAndBelow">
                        <div class="ma-0 pa-0">
                          <v-banner
                            :dark="lightTheme"
                            :light="darkTheme"
                            class="mt-3"
                            color="grey"
                            width="50"
                            height="1"
                          ></v-banner>
                        </div>
                      </show-at>
                      <hide-at breakpoint="mediumAndBelow">
                        <div class="ma-0 pa-0">
                          <v-banner
                            :dark="lightTheme"
                            :light="darkTheme"
                            class="mt-3"
                            color="grey"
                            width="50"
                            height="1"
                          ></v-banner>
                        </div>
                      </hide-at>
                    </v-row>
                    <v-row justify="center">
                      <p
                        style="font-size: 12px; font-weight: 700; opacity: 0.6"
                      >
                        {{ item.title }}
                      </p>
                    </v-row>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider
            class="mx-2 mt-n5"
            style="border-color: #d3d3d3"
          ></v-divider>
          <!-- cardtext4 -->
          <v-card-text class="mt-n3 ml-1">
            <v-row class="">
              <p class="ma-0 pa-0 mt-n1" style="font-weight: 800; opacity: 0.8">
                Tags
                <v-icon
                  style="cursor: pointer"
                  @click="tagsonoff = !tagsonoff"
                  v-if="!tagsonoff"
                  >mdi-menu-right
                </v-icon>
                <v-icon
                  style="cursor: pointer"
                  @click="tagsonoff = !tagsonoff"
                  v-if="tagsonoff"
                  >mdi-menu-down
                </v-icon>
                <v-menu
                  rounded="xl"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  bottom
                  max-width="210"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon> mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-card
                    elevation="0"
                    rounded="xl"
                    width="210"
                    style="overflow: hidden"
                    height="220"
                    class="ma-0 pa-0"
                  >
                    <div style="display: flex" class="pl-4">
                      <h4 style="font-weight: 670">Assign Tags</h4>
                      <v-content class="pl-10 pt-3">
                        <manageTag />
                      </v-content>
                    </div>
                    <v-text-field
                      v-model="searchTag"
                      class="pl-3 pr-3"
                      outlined
                      rounded="lg"
                      dense
                      append-icon="search"
                      label="Find Tags"
                    >
                    </v-text-field>
                    <v-card
                      elevation="0"
                      width="190"
                      height="140"
                      style="overflow-x: hidden"
                      class="mt-n4 ml-2 pr-2 expand"
                    >
                      <v-row class="ml-2 mr-3">
                        <div v-for="(item, index) in localtags" :key="index">
                          <v-chip
                            small
                            @click="tagpassToServer(item.title, item.color)"
                            class="ml-3 mt-2"
                            :color="item.color"
                            >{{ item.title }}
                          </v-chip>
                        </div>
                      </v-row>
                    </v-card>
                  </v-card>
                </v-menu>
                <v-btn icon class="ml-n2">
                  <v-icon @click="showCloseChip = !showCloseChip">
                    mdi-pencil-outline</v-icon
                  >
                </v-btn>
              </p>
            </v-row>

            <v-row class="mt-n4" v-if="tagsonoff">
              <v-col cols="1"></v-col>
              <v-col>
                <v-card
                  tile
                  class="ma-0 pa-0"
                  elevation="0"
                  width="200"
                  min-height="10"
                  color="transparent"
                >
                  <v-row class="ma-0 pa-0">
                    <!-- <v-chip
                        @mouseover="showCloseChip = index"
                        @mouseout="showCloseChip = null"
                        class="ml-1 mt-1"
                        small
                        :color="item1.color"
                        v-for="(item1, index) in file.tags"
                        :key="index"
                        :close="showCloseChip"
                        dark
                        >{{ item1.title }}</v-chip
                      > -->
                    <v-chip
                      class="ml-1 mt-1"
                      small
                      :color="item1.color"
                      v-for="(item1, index) in file.tags"
                      :key="index"
                      :close="showCloseChip"
                      dark
                      @click:close="deleteTagFromServer(index)"
                      >{{ item1.title }}</v-chip
                    >
                  </v-row></v-card
                >
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider
            class="mx-2 mt-n5"
            style="border-color: #d3d3d3"
          ></v-divider>
          <!-- cardtext5 -->
          <v-card-text class="mt-n3 ml-1">
            <v-row class="">
              <p style="font-weight: 800; opacity: 0.8">
                Share Link
                <v-icon
                  style="cursor: pointer"
                  @click="sharelink = !sharelink"
                  v-if="!sharelink"
                  >mdi-menu-right</v-icon
                >
                <v-icon
                  style="cursor: pointer"
                  @click="sharelink = !sharelink"
                  v-if="sharelink"
                  >mdi-menu-down</v-icon
                >
                <v-icon>mdi-plus</v-icon>
              </p>
            </v-row>
            <v-row v-if="sharelink">
              <v-col cols="1"></v-col>
              <v-col class="mt-n1">
                <v-row justify="start" class="ma-0 pa-0">
                  <strong>QRcode</strong>
                  <v-checkbox class="mt-n1" v-model="showQrCode"></v-checkbox>
                  <div class="ma-0 pa-0" id="qrCode" v-if="showQrCode">
                    <v-card
                      v-if="sharelink"
                      width="130"
                      height="130"
                      rounded="xl"
                      elevation="6"
                      class="pt-4 pl-4 ma-0"
                      style="background-color: white"
                    >
                      <qrcode-vue
                        :value="shareLink"
                        size="100"
                        level="H"
                        background="#ffffff"
                        foreground="#000000"
                      ></qrcode-vue>
                    </v-card>
                  </div>
                  <v-btn v-if="showQrCode" icon @click="saveQrCode()"
                    ><v-icon>mdi-qrcode-scan</v-icon></v-btn
                  >
                </v-row>

                <div v-if="sharelink">
                  <!--<a href="https://www.w3schools.com" target="_blank">-->
                  <a
                    :href="getShareLink()"
                    target="_blank"
                    style="color: #70dbdb"
                    >{{ shareLink }}</a
                  >
                  <v-btn v-clipboard="() => shareLink" icon
                    ><v-icon>mdi-content-copy</v-icon></v-btn
                  >
                  <br />

                  <!-- <strong>{{ filePassword }}</strong> 
              <v-btn icon @click="checkFilePassword()"
                ><v-icon>mdi-reload</v-icon></v-btn
              >
              -->
                  <strong>Password</strong>
                  <v-btn v-clipboard="() => filePassword" icon
                    ><v-icon>mdi-content-copy</v-icon></v-btn
                  >
                  <v-btn
                    v-if="file.password_required"
                    icon
                    @click="unlockOrLockFile()"
                    ><v-icon>mdi-lock-outline</v-icon></v-btn
                  >
                  <v-btn
                    v-if="!file.password_required"
                    icon
                    @click="unlockOrLockFile()"
                    ><v-icon>mdi-lock-open-variant-outline</v-icon></v-btn
                  >

                  <!--<v-btn icon><v-icon>mdi-pencil</v-icon></v-btn>-->
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider
            class="mx-2 mt-n5"
            style="border-color: #d3d3d3"
          ></v-divider>
          <!-- cardtext6 -->
          <v-card-text class="mt-n3 ml-1">
            <v-row class="">
              <p style="font-weight: 800; opacity: 0.8">
                Versions
                <v-icon
                  style="cursor: pointer"
                  @click="versions = !versions"
                  v-if="!versions"
                  >mdi-menu-right</v-icon
                >
                <v-icon
                  style="cursor: pointer"
                  @click="versions = !versions"
                  v-if="versions"
                  >mdi-menu-down</v-icon
                >

                <v-icon @click="addVersion()">mdi-plus</v-icon>
              </p>
            </v-row>
            <!-- <v-row
              style="display: flex; justify-content: space-between"
              class="mx-0"
            >
              <p style="font-weight: 800; opacity: 0.8">Versions</p>
              <v-icon @click="addVersion()">mdi-plus</v-icon>
            </v-row> -->
            <v-row class="scrollClass mt-n5" v-if="versions">
              <v-col cols="1"></v-col>
              <v-col>
                <div style="display: flex">
                  <div v-for="(item, index) in fileItems" :key="index">
                    <v-img
                      v-bind:style="
                        item.active
                          ? 'filter: drop-shadow(0 0 0.5rem #419cff)'
                          : 'filter: drop-shadow(0 0 0.5rem #808080)'
                      "
                      rounded
                      contain
                      aspect-ratio="1"
                      width="120"
                      height="120"
                      :src="item.filepng"
                      @click="changeVersionView(item)"
                    >
                    </v-img>
                    <p
                      style="
                        text-align: center;
                        font-weight: 600;
                        font-size: 15px;
                      "
                      v-bind:style="item.active ? 'color: #419cff' : ''"
                    >
                      V{{ formatVersion(item.version) }}
                      <v-icon v-if="index == fileItems.length - 1"
                        >mdi-star</v-icon
                      >
                    </p>
                    <p
                      style="
                        font-weight: 600;
                        opacity: 0.6;
                        font-size: 11px;
                        text-align: center;
                      "
                      v-bind:style="item.active ? 'color: #419cff' : ''"
                      class="mt-n3"
                    >
                      {{ item.created_at }}
                    </p>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider
            class="mx-2 mt-n5"
            style="border-color: #d3d3d3"
          ></v-divider>

          <!-- cardtext7 -->
          <v-card-text class="mt-n3 ml-1">
            <v-row class="">
              <p style="font-weight: 800; opacity: 0.8">
                Colors
                <v-icon
                  style="cursor: pointer"
                  @click="colors = !colors"
                  v-if="!colors"
                  >mdi-menu-right</v-icon
                >
                <v-icon
                  style="cursor: pointer"
                  @click="colors = !colors"
                  v-if="colors"
                  >mdi-menu-down</v-icon
                >
                <v-icon>mdi-plus</v-icon>
              </p>
            </v-row>
            <v-row class="mt-n3" v-if="colors">
              <v-col cols="1"></v-col>
              <v-col>
                <div style="display: flex">
                  <div v-for="(item, index) in localitem" :key="index">
                    <v-avatar
                      class="ml-5"
                      size="30"
                      :color="item.avatarcolor"
                    ></v-avatar>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider
            class="mx-2 mt-n5"
            style="border-color: #d3d3d3"
          ></v-divider>
          <v-card-actions>
            <p
              style="font-weight: 800; opacity: 0.8; cursor: pointer"
              @click="goBackToFiles"
            >
              <v-icon>arrow_left</v-icon>Back to Asset Overview
            </p>
          </v-card-actions>
        </v-card>
      </div>
      <div
        class="
          md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50
          mt-9
        "
      >
        <div class="md-layout mr-n4">
          <div
            class="
              md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100
            "
            style="position: relative"
          >
            <v-card style="border-radius: 20px" elevation="6">
              <fullscreen
                id="Zoom1"
                ref="fullscreen"
                :fullscreen.sync="fullscreen"
                @change="fullscreenChange"
              >
                <div class="ma-0 pa-0 drop-zone">
                  <model-viewer
                    style="width: 100%; min-height: 50vh; border-radius: 50px"
                    id="loading-demo-sub"
                    :src="file.fileglb"
                    :ios-src="file.fileusdz"
                    :poster="file.filepng"
                    interaction-prompt="none"
                    environment-image="neutral"
                    camera-controls
                    ar
                    ar-modes="webxr scene-viewer quick-look"
                    ar-scale="auto"
                    alt="A 3D model of an astronaut"
                    ><button
                      slot="ar-button"
                      style="
                        background-color: white;
                        border-radius: 4px;
                        border: none;
                        position: absolute;
                        top: 16px;
                        right: 16px;
                      "
                    >
                      Activate AR
                    </button>
                  </model-viewer>
                  <input
                    type="file"
                    name="ARfile"
                    id="rr1"
                    class="drop-zone__input"
                  />
                </div>

                <div v-if="fullscreen">
                  <v-btn
                    icon
                    light
                    @click="toggleFullScreen"
                    style="
                      position: absolute !important;
                      z-index: 10000000;
                      right: 4em;
                      bottom: 1.4em;
                    "
                  >
                    <md-icon
                      class="md-size-2x"
                      md-src="/static/assets/svg/black/Exit Fullscreen.svg"
                    ></md-icon>
                  </v-btn>
                </div>
              </fullscreen>

              <v-btn
                icon
                light
                @click="toggleFullScreen"
                style="
                  position: absolute !important;
                  z-index: 2;
                  right: 1em;
                  bottom: 0.8em;
                "
              >
                <md-icon
                  class="md-size-2x"
                  md-src="/static/assets/svg/black/Fullscreen.svg"
                ></md-icon>
              </v-btn>
              <v-btn
                icon
                x-large
                v-on:click="hdrSettings = !hdrSettings"
                style="
                  position: absolute !important;
                  z-index: 1000;
                  left: 1em;
                  top: 0.8em;
                  cursor: pointer;
                "
              >
                <md-icon
                  class="md-size-2x"
                  md-src="/static/assets/svg/black/Settings.svg"
                ></md-icon>
              </v-btn>
              <!-- start viewer settings component -->
              <div v-if="hdrSettings" class="hdrNavigation ma-0 pa-0 ml-5 mt-5">
                <v-container class="ma-0 pa-0">
                  <v-card
                    width="252"
                    elevation="3"
                    min-height="310"
                    style="border-radius: 15px"
                    :style="{
                      background: $vuetify.theme.themes[theme].background,
                    }"
                  >
                    <v-layout>
                      <v-flex>
                        <v-card
                          width="30"
                          elevation="0"
                          height="355"
                          class="ml-1"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                        >
                          <!-- 1st btn -->
                          <div class="ma-0 pa-0">
                            <v-row class="ma-0 pa-0 mt-n3 ml-2">
                              <v-btn icon>
                                <v-icon size="22" @click="lightf()">
                                  mdi-lightbulb-on-outline
                                </v-icon>
                              </v-btn>
                            </v-row>
                            <!-- 2nd btn -->
                            <v-row class="ma-0 pa-0 mt-3 ml-2">
                              <v-btn icon v-on="on">
                                <v-icon size="22" @click="circlef()">
                                  tonality
                                </v-icon>
                              </v-btn>
                            </v-row>
                            <!-- 3rd btn -->
                            <v-row class="ma-0 pa-0 mt-3 ml-2">
                              <v-btn icon>
                                <v-icon size="22" @click="mediaf()">
                                  mdi-play-circle-outline
                                </v-icon>
                              </v-btn>
                            </v-row>
                            <!-- 4th btn -->
                            <!-- <v-row class="ma-0 pa-0 mt-3 ml-2">
                              <v-btn @click="colorbtnf()" icon>
                                <v-icon size="22"> mdi-palette-outline </v-icon>
                              </v-btn>
                            </v-row> -->
                            <v-row class="ma-0 pa-0 mt-3 ml-2">
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn icon v-on="on">
                                    <v-icon size="22" @click="boxbtnf()">
                                      mdi-palette-outline
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>Beta 1.2</span>
                              </v-tooltip>
                            </v-row>

                            <!-- 5th btn -->
                            <!-- <v-row class="ma-0 pa-0 mt-3 ml-2"> -->
                            <!-- <md-icon class="md-size-1x" md-src="/static/assets/svg/black/photo.svg"/> -->
                            <!-- <v-btn @click="boxbtnf()" icon> -->
                            <!-- <v-btn @click="boxbtnf()" icon>
                                <v-icon size="22"> mdi-texture </v-icon>
                              </v-btn>
                            </v-row> -->
                            <!-- 5th btn -->
                            <v-row class="ma-0 pa-0 mt-3 ml-2">
                              <!-- <md-icon class="md-size-1x" md-src="/static/assets/svg/black/filetype.svg"/> -->
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn icon v-on="on">
                                    <v-icon size="22" @click="filebtnf()">
                                      description
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>Beta 1.2</span>
                              </v-tooltip>
                            </v-row>
                            <!-- 6th btn -->
                            <v-row class="ma-0 pa-0 mt-2 ml-2">
                              <!-- <md-icon class="md-size-1x" md-src="/static/assets/svg/black/filetype.svg"/> -->
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn icon v-on="on">
                                    <v-icon size="22" @click="photobtnf()">
                                      photo_size_select_large
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>Beta 1.2</span>
                              </v-tooltip>
                            </v-row>
                            <!-- 7th btn -->
                            <v-row class="ma-0 pa-0 mt-2 ml-2">
                              <v-btn icon>
                                <v-icon size="22" @click="saveFileConfig()">
                                  mdi-auto-upload
                                </v-icon>
                              </v-btn>
                            </v-row>
                            <!-- 7th btn -->
                            <v-row class="ma-0 pa-0 mt-2 ml-2">
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn icon v-on="on">
                                    <v-icon size="22"> mdi-undo </v-icon>
                                  </v-btn>
                                </template>
                                <span>Beta 1.2</span>
                              </v-tooltip>
                            </v-row>
                          </div>
                        </v-card>
                      </v-flex>

                      <v-divider
                        class="mt-2 mb-5"
                        style="border-color: #d3d3d3"
                        vertical
                      ></v-divider>

                      <v-flex>
                        <!-- 1st card -->
                        <v-card
                          v-if="lightbutton"
                          width="170"
                          elevation="0"
                          min-height="300"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          class="ma-0 pa-0 mt-4 ml-2"
                        >
                          <p
                            class="caption-11 ml-3"
                            style="font-weight: 700; opacity: 0.8"
                          >
                            Enviorment
                          </p>
                          <p
                            class="ml-3"
                            style="font-size: 11px; font-weight: 650"
                          >
                            Active HDR (Share Page)
                          </p>

                          <v-select
                            :items="hdrFileItems"
                            v-model="hdrItem"
                            item-text="file_name"
                            item-value="file_hdr"
                            dense
                            class="ml-1 mt-n2"
                            rounded
                            outlined
                            @input="hdrSelectActive(hdrItem)"
                          >
                          </v-select>

                          <v-row>
                            <v-col cols="9">
                              <p
                                class="caption-11"
                                style="
                                  font-weight: 700;
                                  opacity: 0.8;
                                  margin-top: -2.2em;
                                "
                              >
                                Use Enviorment as skyBox
                              </p>
                            </v-col>
                            <v-col cols="2">
                              <v-checkbox
                                v-model="asSkybox"
                                style="margin-top: -2.2em"
                              >
                              </v-checkbox>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="9">
                              <p
                                class="caption-11"
                                style="
                                  font-weight: 700;
                                  opacity: 0.8;
                                  margin-top: -2.2em;
                                "
                              >
                                Neutral Light
                              </p>
                            </v-col>
                            <v-col cols="2">
                              <v-checkbox
                                v-model="neutralLight"
                                style="margin-top: -2.2em"
                              >
                              </v-checkbox>
                            </v-col>
                          </v-row>
                          <p
                            class="caption-11"
                            style="
                              font-weight: 700;
                              opacity: 0.8;
                              margin-top: -1.3em;
                            "
                          >
                            HDRI light rotation
                          </p>
                          <v-slider
                            thumb-label
                            track-color="grey"
                            class="mt-n4"
                            track-fill-color="grey"
                          >
                          </v-slider>
                          <p
                            class="caption-11"
                            style="
                              font-weight: 700;
                              opacity: 0.8;
                              margin-top: -2em;
                            "
                          >
                            Brightness
                          </p>
                          <v-slider
                            v-model="hdrExposure"
                            thumb-label
                            min="0"
                            max="2"
                            step="0.1"
                            class="mt-n4"
                            track-color="grey"
                            track-fill-color="grey"
                          >
                          </v-slider>
                          <!-- <p
                            class="caption-11"
                            style="
                              font-weight: 700;
                              opacity: 0.8;
                              margin-top: -2em;
                            "
                          >
                            Brightness
                          </p>
                          <v-slider
                            thumb-label
                            track-color="grey"
                            class="mt-n4"
                            track-fill-color="grey"
                          >
                          </v-slider> -->
                          <v-row class="mt-n8">
                            <v-col cols="6">
                              <p
                                class="caption-11"
                                style="font-weight: 700; opacity: 0.8"
                              >
                                HDR List
                              </p>
                            </v-col>
                            <v-col cols="3">
                              <v-icon
                                @click="hdrlist = !hdrlist"
                                color="blue"
                                class="ml-n5"
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                            <v-col cols="2">
                              <v-icon size="22" @click="addHDR()"
                                >mdi-plus</v-icon
                              >
                            </v-col>
                          </v-row>
                          <div v-if="hdrlist">
                            <v-card
                              elevation="0"
                              height="130"
                              class="expand mt-n3"
                              :style="{
                                background:
                                  $vuetify.theme.themes[theme].background,
                              }"
                            >
                              <v-card-text>
                                <div
                                  v-for="(item, index) in hdrFileItems"
                                  :key="index"
                                >
                                  <v-row class="ma-0 pa-0">
                                    <v-col cols="8">
                                      <p
                                        style="cursor: pointer"
                                        @click="hdrSelect(item.file_hdr)"
                                      >
                                        {{ item.file_name }}
                                      </p>
                                    </v-col>
                                    <v-col cols="4">
                                      <v-btn icon @click="deleteHDR(item.id)">
                                        <v-icon> mdi-delete-outline </v-icon>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                  <v-divider
                                    style="border-color: #d3d3d3"
                                    class="ml-2 mr-2"
                                  ></v-divider>
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                        </v-card>

                        <!-- 2nd card -->
                        <v-card
                          v-if="circlebutton"
                          width="170"
                          elevation="0"
                          min-height="280"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          class="ma-0 pa-0 mt-n3 ml-2"
                        >
                          <p
                            class="caption-11 mt-8"
                            style="font-weight: 700; opacity: 0.8"
                          >
                            Shadow Intensity
                          </p>
                          <div class="ma-0 pa-0" style="display: flex">
                            <v-slider
                              class="mt-n5"
                              v-model="shadowIntensity"
                              min="0.0"
                              step="0.1"
                              max="10.0"
                              thumb-label
                              track-color="grey"
                              track-fill-color="grey"
                            >
                            </v-slider>
                            <p
                              class="caption-11 mt-n5"
                              style="font-weight: 700; opacity: 0.8"
                            >
                              {{ computedShadowIntensity }}
                              <v-btn icon>
                                <v-icon> mdi-undo </v-icon>
                              </v-btn>
                            </p>
                          </div>
                          <p
                            class="caption-11 mt-n3"
                            style="font-weight: 700; opacity: 0.8"
                          >
                            Shadow Softness
                          </p>
                          <div class="ma-0 pa-0" style="display: flex">
                            <v-slider
                              class="mt-n5"
                              v-model="shadowSoftness"
                              min="0.0"
                              step="0.1"
                              max="1.0"
                              thumb-label
                              track-color="grey"
                              track-fill-color="grey"
                            >
                            </v-slider>
                            <p
                              class="caption-11 mt-n5"
                              style="font-weight: 700; opacity: 0.8"
                            >
                              {{ computedShadowSoftness }}
                              <v-btn icon>
                                <v-icon> mdi-undo </v-icon>
                              </v-btn>
                            </p>
                          </div>

                          <!-- <p
                            class="caption-11 mt-n3"
                            style="font-weight: 700; opacity: 0.8"
                          >
                            Contrast
                          </p>
                          <v-slider
                            class="mt-n5"
                            thumb-label
                            track-color="grey"
                            track-fill-color="grey"
                          >
                          </v-slider> -->
                          <!-- <p
                            class="caption-11 mt-n3"
                            style="font-weight: 700; opacity: 0.8"
                          >
                            Saturation
                          </p>
                          <v-slider
                            class="mt-n5"
                            thumb-label
                            track-color="grey"
                            track-fill-color="grey"
                          >
                          </v-slider> -->
                          <div style="display: flex" class="mt-n3">
                            <p>Wireframe</p>
                            <v-checkbox class="mt-n2 ml-8"></v-checkbox>
                          </div>
                          <div style="display: flex" class="mt-n3">
                            <p>Shaded</p>
                            <v-checkbox class="mt-n2 ml-13"></v-checkbox>
                          </div>
                          <div style="display: flex" class="mt-n3">
                            <p>Double Sided</p>
                            <v-checkbox class="mt-n2 ml-4"></v-checkbox>
                          </div>
                        </v-card>

                        <!-- 3 card -->
                        <v-card
                          v-if="mediabutton"
                          width="170"
                          elevation="0"
                          min-height="370"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          class="ma-0 pa-0 mt-3 ml-2"
                        >
                          <!-- <v-row>
                            <v-col cols="9">
                              <p
                                class="caption-11"
                                style="font-weight: 600; opacity: 0.8"
                              >
                                Enable turnable
                              </p>
                            </v-col>
                            <v-col cols="2">
                              <v-checkbox
                                v-model="glbRotation"
                                style="margin-top: -0.5em"
                              >
                              </v-checkbox>
                            </v-col>
                          </v-row>
                          <v-row style="margin-top: -3em">
                            <v-col cols="1">
                              <v-icon @click="directionClockWise = true">
                                mdi-axis-z-rotate-counterclockwise
                              </v-icon>
                            </v-col>
                            <v-col cols="1">
                              <v-icon @click="directionClockWise = false">
                                mdi-axis-z-rotate-clockwise
                              </v-icon>
                            </v-col>
                          </v-row>
                          <p
                            class="caption-11 mt-n1 mb-n1"
                            style="font-weight: 600; opacity: 0.8"
                          >
                            Speed of Turnable
                          </p>
                          <v-slider
                            v-model="speedAndDirectionOfModel"
                            min="20"
                            max="800"
                            step="5"
                            thumb-label
                            track-color="grey"
                            track-fill-color="grey"
                          >
                          </v-slider> -->

                          <!-- Animation Settings -->
                          <div class="ma-0 pa-0 mt-5">
                            <p class="ml-1 caption-11">
                              Animation Settings<v-icon
                                v-if="!animationAnimationSettings"
                                class="ml-3"
                                size="22"
                                color="primary"
                                @click="
                                  animationAnimationSettings =
                                    !animationAnimationSettings
                                "
                                >mdi-menu-right</v-icon
                              >
                              <v-icon
                                v-if="animationAnimationSettings"
                                class="ml-3"
                                size="22"
                                color="primary"
                                @click="
                                  animationAnimationSettings =
                                    !animationAnimationSettings
                                "
                                >mdi-menu-down</v-icon
                              >
                            </p>
                          </div>
                          <div
                            class="ma-0 pa-0 mt-n2 ml-2"
                            v-if="animationAnimationSettings"
                          >
                            <p style="font-size: 11px">Base Animation</p>
                            <v-row class="mt-n2 mr-1">
                              <v-select
                                :items="animationList"
                                v-model="animationSelect"
                                dense
                                outlined
                                class="ml-2"
                                rounded
                                @input="animationSelected(animationSelect)"
                              >
                              </v-select>
                            </v-row>

                            <div
                              class="ma-0 pa-0 mx-2 mt-n3"
                              v-for="(item, index) in selectedAnimationList"
                              :key="index"
                            >
                              <div style="display: flex; font-size: 11px">
                                <div class="ma-0 pa-0">
                                  <p class="mr-3">{{ index + 1 }}.</p>
                                </div>
                                <div class="ma-0 pa-0">
                                  <p>
                                    {{ item }}
                                  </p>
                                </div>
                                <v-spacer></v-spacer>
                                <div class="ma-0 pa-0 mr-1">
                                  <v-icon
                                    size="15"
                                    @click="removeSelectedAnimationList(index)"
                                    >mdi-close</v-icon
                                  >
                                </div>
                                <div class="ma-0 pa-0">
                                  <v-icon size="15">mdi-drag</v-icon>
                                </div>
                              </div>
                            </div>

                            <v-row justify="center" class="ma-0 pa-0 mt-n2">
                              <v-menu
                                rounded="lg"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                bottom
                                max-width="200"
                              >
                                <template v-slot:activator="{ on }">
                                  <p
                                    style="
                                      font-size: 11px;
                                      color: #419cff;
                                      cursor: pointer;
                                    "
                                    v-on="on"
                                  >
                                    Select Animationclip<v-icon
                                      size="15"
                                      class="ml-2"
                                      color="primary"
                                      >mdi-plus</v-icon
                                    >
                                  </p>
                                </template>

                                <v-card
                                  class="ma-0 pa-0"
                                  width="200"
                                  height="200"
                                  rounded="lg"
                                  :style="{
                                    background:
                                      $vuetify.theme.themes[theme].background,
                                  }"
                                  ><div class="pl-7 pr-7 pt-2 ma-0">
                                    <p class="display-22">
                                      <strong>Animation Clips</strong>
                                    </p>

                                    <v-card
                                      elevation="0"
                                      width="200"
                                      height="145"
                                      style="overflow-x: hidden"
                                      class="ma-0 pa-0 mt-n2 mb-2 expand"
                                      :style="{
                                        background:
                                          $vuetify.theme.themes[theme]
                                            .background,
                                      }"
                                    >
                                      <div
                                        class="ma-0 pa-0"
                                        v-for="(
                                          item, index
                                        ) in computedSelectedAnimationList"
                                        :key="index"
                                      >
                                        <div
                                          class="ma-0 pa-0 mt-1 mb-n2"
                                          style="
                                            display: flex;
                                            justify-content: start;
                                          "
                                        >
                                          <p
                                            style="cursor: pointer"
                                            class="caption-11"
                                            @click="
                                              selectedAnimationListFunc(item)
                                            "
                                          >
                                            {{ item }}
                                          </p>
                                        </div>
                                        <v-divider
                                          class="pl-5 pr-5 mt-n3"
                                          style="border-color: #d3d3d3"
                                        ></v-divider>
                                      </div>
                                    </v-card>
                                  </div>
                                </v-card>
                              </v-menu>
                            </v-row>
                          </div>

                          <!-- Blend Animation -->
                          <div class="ma-0 pa-0">
                            <p class="ml-1 caption-11">
                              Blend Animations<v-icon
                                v-if="!animationBlendAnimations"
                                class="ml-3"
                                size="22"
                                color="primary"
                                @click="
                                  animationBlendAnimations =
                                    !animationBlendAnimations
                                "
                                >mdi-menu-right</v-icon
                              >
                              <v-icon
                                v-if="animationBlendAnimations"
                                class="ml-3"
                                size="22"
                                color="primary"
                                @click="
                                  animationBlendAnimations =
                                    !animationBlendAnimations
                                "
                                >mdi-menu-down</v-icon
                              >
                            </p>
                          </div>
                          <div
                            class="ma-0 pa-0 ml-2 mr-1"
                            v-if="animationBlendAnimations"
                          >
                            <div style="display: flex" class="mt-n1">
                              <div class="ma-0 pa-0">
                                <p style="font-size: 10px">Combine animation</p>
                              </div>
                              <v-spacer></v-spacer>
                              <div class="ma-0 pa-0">
                                <v-checkbox
                                  v-model="animationCombined"
                                  class="mt-n2 mr-n2"
                                >
                                </v-checkbox>
                              </div>
                            </div>
                            <v-row class="mt-n4">
                              <v-select
                                :items="animationList2nd"
                                v-model="animationSelect2nd"
                                dense
                                class="ml-2"
                                rounded
                                outlined
                                @input="
                                  insertOtherAnimationSelected(
                                    animationSelect2nd
                                  )
                                "
                              >
                              </v-select>
                            </v-row>
                          </div>
                          <!-- Animation Controls -->
                          <v-card
                            width="170"
                            elevation="0"
                            rounded="lg"
                            min-height="30"
                            class="ma-0 pa-0 ml-1 mt-3 pl-2 pb-2 pt-2 pr-2 mb-4"
                            v-bind:color="
                              augmentableTheme ? '#808080' : '#e0e0e0'
                            "
                          >
                            <v-card
                              width="170"
                              elevation="0"
                              rounded="lg"
                              height="20"
                              class="ma-0 pa-0 mb-n2"
                              v-bind:color="
                                augmentableTheme ? '#808080' : '#e0e0e0'
                              "
                            >
                              <div class="ma-0 pa-0" style="display: flex">
                                <div class="ma-0 pa-0">
                                  <p style="font-size: 10px">
                                    Animation Controls
                                  </p>
                                </div>
                                <v-spacer></v-spacer>
                                <div class="ma-0 pa-0 mt-n1">
                                  <v-icon
                                    v-if="!animationAnimationControls"
                                    class="ml-3"
                                    size="22"
                                    color="primary"
                                    @click="
                                      animationAnimationControls =
                                        !animationAnimationControls
                                    "
                                    >mdi-menu-right</v-icon
                                  >
                                  <v-icon
                                    v-if="animationAnimationControls"
                                    class="ml-3"
                                    size="22"
                                    color="primary"
                                    @click="
                                      animationAnimationControls =
                                        !animationAnimationControls
                                    "
                                    >mdi-menu-down</v-icon
                                  >
                                </div>
                              </div>
                            </v-card>

                            <div
                              class="ma-0 pa-0 mt-3"
                              v-if="animationAnimationControls"
                            >
                              <div class="ma-0 pa-0">
                                <p class="caption-11 mt-n2 mb-n1">
                                  Animation Speed
                                </p>
                                <v-slider
                                  min="20"
                                  max="800"
                                  step="5"
                                  thumb-label
                                  track-color="grey"
                                  track-fill-color="grey"
                                >
                                </v-slider>
                              </div>
                              <div
                                class="ma-0 pa-0 mt-n6"
                                style="
                                  display: flex;
                                  justify-content: space-between;
                                "
                              >
                                <div class="ma-0 pa-0 mt-2">
                                  <v-icon
                                    size="20"
                                    @click="playPreviousAnimation()"
                                    >mdi-skip-previous</v-icon
                                  >
                                </div>
                                <div
                                  class="ma-0 pa-0"
                                  v-if="!glbAnimationButton"
                                >
                                  <v-icon
                                    size="35"
                                    @click="glbAnimation = !glbAnimation"
                                    >mdi-play-circle-outline</v-icon
                                  >
                                </div>
                                <div
                                  class="ma-0 pa-0"
                                  v-if="glbAnimationButton"
                                >
                                  <v-icon
                                    size="35"
                                    color="primary"
                                    @click="glbAnimation = !glbAnimation"
                                    >mdi-pause</v-icon
                                  >
                                </div>
                                <div class="ma-0 pa-0 mt-2">
                                  <v-icon size="20" @click="playNextAnimation()"
                                    >mdi-skip-next</v-icon
                                  >
                                </div>
                                <div
                                  class="ma-0 pa-0 mt-2"
                                  v-if="animationLoopButton"
                                >
                                  <v-icon
                                    size="15"
                                    color="primary"
                                    @click="animationLoop = !animationLoop"
                                    >mdi-sync</v-icon
                                  >
                                </div>
                                <div
                                  class="ma-0 pa-0 mt-2"
                                  v-if="!animationLoopButton"
                                >
                                  <v-icon
                                    size="15"
                                    @click="animationLoop = !animationLoop"
                                    >mdi-sync</v-icon
                                  >
                                </div>
                              </div>
                            </div>
                          </v-card>
                          <!-- <div style="display: flex" class="ma-0 pa-0 mt-3">
                  <div class="ma-0 pa-0">
                    <p
                      class="caption-11"
                      style="font-weight: 600; opacity: 0.8"
                    >
                      Enable animation
                    </p>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="ma-0 pa-0">
                    <v-checkbox v-model="glbAnimation" class="mt-n1 mr-n2">
                    </v-checkbox>
                  </div>
                </div>
                <div style="display: flex" class="mt-n3">
                  <div class="ma-0 pa-0">
                    <p
                      class="caption-11"
                      style="font-weight: 600; opacity: 0.8"
                    >
                      Loop
                    </p>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="ma-0 pa-0">
                    <v-checkbox v-model="animationLoop" class="mt-n1 mr-n2">
                    </v-checkbox>
                  </div>
                </div>
                <p
                  class="caption-11 mt-n3"
                  style="font-weight: 600; opacity: 0.8"
                >
                  Active Animation
                </p>
                <v-row class="mt-n2">
                  <v-select
                    :items="animationList"
                    v-model="animationSelect"
                    dense
                    class="ml-2"
                    rounded
                    outlined
                    @input="animationSelected(animationSelect)"
                  >
                  </v-select>
                </v-row>
                <div style="display: flex" class="mt-n3">
                  <div class="ma-0 pa-0">
                    <p
                      class="caption-11"
                      style="font-weight: 600; opacity: 0.8"
                    >
                      Combine animation
                    </p>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="ma-0 pa-0">
                    <v-checkbox v-model="animationCombined" class="mt-n1 mr-n2">
                    </v-checkbox>
                  </div>
                </div>
                <v-row class="mt-n2">
                  <v-select
                    :items="animationList2nd"
                    v-model="animationSelect2nd"
                    dense
                    class="ml-2"
                    rounded
                    outlined
                    @input="insertOtherAnimationSelected(animationSelect2nd)"
                  >
                  </v-select>
                </v-row> -->

                          <!-- <h5 style="margin-top: -0.9em">Speed</h5>
                <v-slider
                  thumb-label
                  track-color="grey"
                  track-fill-color="grey"
                >
                </v-slider> -->
                        </v-card>

                        <!-- 4 card -->

                        <v-card
                          v-if="colorbtncard"
                          width="170"
                          elevation="0"
                          min-height="280"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          class="ma-0 pa-0 mt-3 ml-2"
                        >
                          <v-flex class="ma-0 pa-0">
                            <v-avatar
                              class="mt-4 mr-4 ml-4"
                              v-for="(item, index) in itemscolor"
                              :key="index"
                              :color="item.color"
                              @click="colorf(item)"
                              size="16"
                            ></v-avatar>
                          </v-flex>
                        </v-card>

                        <!-- 5 card -->
                        <v-card
                          v-if="boxbtncard"
                          width="170"
                          elevation="0"
                          min-height="370"
                          max-height="500"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          class="ma-0 pa-0 mt-3 ml-2 expand1"
                        >
                          <v-row class="">
                            <v-col cols="7">
                              <p class="caption-11 pl-2">Materials</p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon class="mt-n2">search</v-icon>
                            </v-col>
                            <v-col cols="1">
                              <v-menu
                                offset-y
                                left
                                min-width="145"
                                rounded="lg"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    class="mt-n2 ml-1"
                                    v-on="on"
                                    size="20"
                                    color="black"
                                    >mdi-plus</v-icon
                                  >
                                </template>
                                <v-card
                                  elevation="4"
                                  width="145"
                                  class="ma-0 pa-0"
                                  height="107"
                                  :style="{
                                    background:
                                      $vuetify.theme.themes[theme].background,
                                  }"
                                  rounded="lg"
                                >
                                  <div style="display: flex" class="pl-2 pt-2">
                                    <v-icon>mdi-content-copy</v-icon>
                                    <p
                                      style="font-weight: 450"
                                      class="pt-2 pl-2"
                                    >
                                      Duplicate
                                    </p>
                                  </div>
                                  <v-divider
                                    style="border-color: #d3d3d3"
                                    class="ml-2 mr-2"
                                  ></v-divider>
                                  <div style="display: flex" class="pl-2 pt-1">
                                    <v-icon class="mt-n2">mdi-plus</v-icon>
                                    <p
                                      style="font-weight: 450"
                                      class="ml-2 mt-1"
                                    >
                                      Create new
                                    </p>
                                  </div>
                                </v-card>
                              </v-menu>
                            </v-col>
                            <v-col cols="1"> </v-col>
                          </v-row>
                          <p
                            class="ml-2 mt-n6"
                            style="font-weight: 400 !important; font-size: 10px"
                          >
                            Select Material
                          </p>

                          <v-select
                            :items="items"
                            background-color="#F5F5F5"
                            solo
                            dense
                            style="border-radius: 1.5em !important"
                            label="material"
                            class="ml-1 mr-2 mt-n3 mb-n5"
                          >
                          </v-select>

                          <v-row class="ml-1 mt-n6">
                            <v-col cols="8">
                              <p class="caption-11">Transparency</p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon
                                @click="transparency = !transparency"
                                size="22"
                                color="blue"
                                class="ml-n2"
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                          </v-row>
                          <div v-if="transparency" class="mt-n6">
                            <p
                              style="font-size: 10px; font-weight: 500"
                              class="ml-5"
                            >
                              Transparency Mode
                            </p>

                            <v-select
                              :items="items"
                              solo
                              dense
                              background-color="#F5F5F5"
                              label="material"
                              class="mb-n6 mt-n3 mr-2"
                              style="border-radius: 1.5em !important"
                            >
                            </v-select>
                            <p
                              style="font-size: 10px; font-weight: 500"
                              class="mt-2 ml-5"
                            >
                              Alpha Mode
                            </p>
                            <div>
                              <v-select
                                :items="items"
                                solo
                                dense
                                style="border-radius: 1.5em !important"
                                background-color="#F5F5F5"
                                label="material"
                                class="mb-n6 mt-n3 mr-2"
                              >
                              </v-select>
                            </div>
                            <p
                              style="font-size: 10px; font-weight: 500"
                              class="mt-2 ml-5"
                            >
                              Alpha
                            </p>
                            <v-slider class="mt-n5" thumb-label color="grey">
                            </v-slider>
                            <div style="display: flex" class="mt-n8 mb-n4">
                              <v-list
                                :style="{
                                  background:
                                    $vuetify.theme.themes[theme].background,
                                }"
                              >
                                <v-list-item style="font-size: 11px !important">
                                  Use alpha from albedo texture
                                </v-list-item>
                              </v-list>
                              <v-checkbox></v-checkbox>
                            </div>
                          </div>
                          <v-row class="ml-1 mt-n7">
                            <v-col cols="8">
                              <p class="caption-11">Base Color</p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon size="22" color="blue" class="ml-n2"
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                          </v-row>

                          <v-row class="ml-1 mt-n7">
                            <v-col cols="8">
                              <p class="caption-11">Metalness</p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon
                                @click="metalness = !metalness"
                                size="22"
                                color="blue"
                                class="ml-n2"
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                          </v-row>
                          <div v-if="metalness" class="mt-n6">
                            <div style="display: flex">
                              <v-menu offset-y min-width="100" rounded="lg">
                                <template v-slot:activator="{ on }">
                                  <v-card
                                    v-on="on"
                                    elevation="0"
                                    width="30"
                                    height="30"
                                    color="yellow"
                                    class="mt-2 ml-5"
                                  >
                                  </v-card>
                                </template>
                                <v-card
                                  elevation="5"
                                  rounded="lg"
                                  width="100"
                                  height="100"
                                  color="#F5F5F5"
                                  class="ma-0 pa-0"
                                >
                                  <p class="pt-2 pl-2" style="font-size: 12px">
                                    Textures
                                  </p>
                                </v-card>
                              </v-menu>
                              <p
                                style="font-size: 11px; font-weight: 500"
                                class="ml-3 mt-4"
                              >
                                Texture
                              </p>
                            </div>
                            <p
                              style="font-size: 10px; font-weight: 500"
                              class="ml-5"
                            >
                              Metalic Factor
                            </p>
                            <v-slider class="mt-n5" thumb-label color="grey">
                            </v-slider>
                            <p
                              style="font-size: 10px; font-weight: 500"
                              class="ml-5 mt-n6"
                            >
                              Roughness Factor
                            </p>
                            <v-slider
                              class="mt-n5 mb-n8"
                              thumb-label
                              color="grey"
                            >
                            </v-slider>
                          </div>

                          <v-row class="ml-1 mt-n7">
                            <v-col cols="8">
                              <p class="caption-11">Roughness</p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon size="22" color="blue" class="ml-n2"
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                          </v-row>

                          <v-row class="ml-1 mt-n7">
                            <v-col cols="8">
                              <p class="caption-11">Occlusion</p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon
                                @click="occlusion = !occlusion"
                                size="22"
                                color="blue"
                                class="ml-n2"
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                          </v-row>
                          <div v-if="occlusion" class="mt-n5">
                            <div style="display: flex">
                              <v-menu offset-y min-width="100" rounded="lg">
                                <template v-slot:activator="{ on }">
                                  <v-card
                                    v-on="on"
                                    elevation="0"
                                    width="30"
                                    height="30"
                                    color="blue"
                                    class="mt-2 ml-5"
                                  >
                                  </v-card>
                                </template>
                                <v-card
                                  elevation="5"
                                  rounded="lg"
                                  width="100"
                                  height="100"
                                  color="#F5F5F5"
                                  class="ma-0 pa-0"
                                >
                                  <p class="pt-2 pl-2" style="font-size: 12px">
                                    Textures
                                  </p>
                                </v-card>
                              </v-menu>
                              <p
                                style="font-size: 11px; font-weight: 500"
                                class="ml-3 mt-4"
                              >
                                Texture
                              </p>
                            </div>
                            <p
                              style="font-size: 10px; font-weight: 500"
                              class="ml-5"
                            >
                              Strength
                            </p>
                            <v-slider
                              class="mt-n5 mb-n8"
                              thumb-label
                              color="grey"
                            >
                            </v-slider>
                          </div>

                          <v-row class="ml-1 mt-n7">
                            <v-col cols="8">
                              <p class="caption-11">Normals</p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon size="22" color="blue" class="ml-n2"
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                          </v-row>
                        </v-card>

                        <!-- 6 card -->
                        <v-card
                          v-if="filebtncard"
                          width="170"
                          elevation="0"
                          min-height="280"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          class="ma-0 pa-0 mt-3 ml-2"
                        >
                          <!-- <v-flex class="pt-2 pb-5">
                            <v-btn text style="width: 90%">
                              <p
                                class="caption-11 pt-2"
                                style="font-weight: 700; opacity: 0.8"
                              >
                                Original File
                              </p>
                            </v-btn>
                          </v-flex> -->
                          <!-- <div v-for="(item, index) in filebtns1" :key="index" >
                          <v-row class="originalnot" style="background-color:#419cff;" v-if="item.checked">
                       <p
                                  class="caption-11 pt-2"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                >
                                   {{item.title}}
                                </p>
                          </v-row>
                          <v-row class="originalnot"  v-if="!item.checked">
                       <p
                                  class="caption-11 pt-2"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                >
                                 {{item.title}}
                                </p>
                          </v-row>
                          </div> -->
                          <div v-for="(item, index) in filebtns" :key="index">
                            <v-row
                              class="ml-1 mb-3"
                              v-if="
                                item.name === 'Original File' && item.checked
                              "
                              style="
                                background-color: #b3e5fc;
                                height: 2.5em;
                                border-radius: 10px;
                                opacity: 0.8;
                              "
                              @click="selectviewerfile(index)"
                            >
                              <v-col cols="9">
                                <p
                                  class="caption-11 mt-n1"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                >
                                  {{ item.name }}
                                </p>
                              </v-col>
                              <v-col cols="1"> </v-col>
                            </v-row>
                            <v-row
                              class="ml-1 mb-3"
                              v-if="
                                item.name === 'Original File' && !item.checked
                              "
                              @click="selectviewerfile(index)"
                              style="height: 2.5em"
                            >
                              <v-col cols="9">
                                <p
                                  class="caption-11 mt-n1"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                >
                                  {{ item.name }}
                                </p>
                              </v-col>
                              <v-col cols="1"> </v-col>
                            </v-row>
                            <v-row
                              class="ml-1 mt-n1 mb-2"
                              style="
                                background-color: #b3e5fc;
                                height: 2.5em;
                                border-radius: 10px;
                                opacity: 0.8;
                              "
                              v-if="
                                item.checked && item.name !== 'Original File'
                              "
                              @click="selectviewerfile(index)"
                            >
                              <div style="display: flex" class="pl-2 mt-n1">
                                <md-icon
                                  v-if="augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg1"
                                />
                                <md-icon
                                  v-if="!augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg2"
                                />
                                <p
                                  class="caption-11 mt-3 ml-2"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                >
                                  {{ item.name }}
                                </p>
                              </div>
                            </v-row>
                            <v-row
                              class="ml-1 mt-n1 mb-2"
                              v-if="
                                !item.checked && item.name !== 'Original File'
                              "
                              @click="selectviewerfile(index)"
                            >
                              <div style="display: flex" class="pl-2 mt-n1">
                                <md-icon
                                  v-if="augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg1"
                                />
                                <md-icon
                                  v-if="!augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg2"
                                />
                                <p
                                  class="caption-11 mt-3 ml-2"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                >
                                  {{ item.name }}
                                </p>
                              </div>
                            </v-row>
                          </div>
                          <!-- <v-row v-for="(item, index) in filebtns" :key="index" >
                            <v-row class="originalnot" v-if="item.name==='ORIGINAL FILE' || item.checked" 
                            style="background-color:#419cff;"
                            >
                              <v-col cols="8">
                                <p
                                  class="caption-11 pt-2"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                >
                                  {{ item.name }}
                                </p>
                              </v-col>
                              <v-col cols="2"> </v-col>
                            </v-row>
                            <v-row class="originalnot" v-if="item.name==='ORIGINAL FILE' || " 
                            >
                              <v-col cols="8">
                                <p
                                  class="caption-11 pt-2"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                  v-if="!item.checked"
                                >
                                  {{ item.name }}
                                </p>
                              </v-col>
                              <v-col cols="2"> </v-col>
                            </v-row>
                            <v-row
                            class="originalnot"
                            style="background-color:#419cff;"
                              v-if="item.name !=='ORIGINAL FILE' || item.checked"
                              @click="checkExportFiles(item, index)"
                            >
                              <div  style="display:flex;">
                                <md-icon
                                  v-if="augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg1"
                                />
                                <md-icon
                                  v-if="!augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg2"
                                />
                                <p
                                  class="caption-11 mt-3 ml-2"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                >
                                  {{ item.name }}
                                </p>
                             </div>
                            
                            </v-row>
                             <v-row
                            class="originalnot"
                              v-if="item.name !=='ORIGINAL FILE' || !item.checked"
                              @click="checkExportFiles(item, index)"
                            >
                              <div  style="display:flex;">
                                <md-icon
                                  v-if="augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg1"
                                />
                                <md-icon
                                  v-if="!augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg2"
                                />
                                <p
                                  class="caption-11 mt-3 ml-2"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                >
                                  {{ item.name }}
                                </p>
                             </div>
                            </v-row> -->
                          <!-- <v-row
                              v-if="item.name !== 'ORIGINAL FILE'"
                              @click="checkExportFiles(item, index)"
                              class="mt-n11"
                            >
                              <v-col cols="1" class="ml-3">
                                <md-icon
                                  v-if="augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg1"
                                />
                                <md-icon
                                  v-if="!augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg2"
                                />
                              </v-col>
                              <v-col cols="7">
                                <p
                                  class="caption-11 mt-1 ml-2"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                >
                                  {{ item.name }}
                                </p>
                              </v-col>
                              <v-col cols="1">
                                <v-checkbox
                                  v-model="item.checked"
                                  class="mt-n1"
                                  @click="checkExportFiles(item, index)"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="1"> </v-col>
                            </v-row> -->
                          <!-- </v-row> -->
                        </v-card>
                        <!-- 7th card -->
                        <v-card
                          v-if="photobtncard"
                          width="170"
                          elevation="0"
                          min-height="280"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          class="ma-0 pa-0 mt-3 ml-2"
                        >
                          <v-row class="">
                            <v-col cols="8">
                              <p class="ml-1 mt-n1 caption-11">
                                Resize Textures
                              </p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon
                                class="mt-n2 ml-n2"
                                size="22"
                                color="#01579B"
                                @click="
                                  photomaterialtexture = !photomaterialtexture
                                "
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                            <v-col cols="1">
                              <v-checkbox class="mt-n2"></v-checkbox>
                            </v-col>
                            <v-col cols="1"> </v-col>
                          </v-row>

                          <div
                            v-if="photomaterialtexture"
                            class="ma-0 pa-0 mt-n14 ml-1 mb-8"
                          >
                            <p
                              style="font-size: 10px; font-weight: 450"
                              class="ml-2"
                            >
                              Texture Format
                            </p>
                            <v-select
                              rounded
                              outlined
                              dense
                              label="Same as Sourse"
                              class="mt-n3"
                              :item="textureitem"
                            >
                            </v-select>
                            <!-- <div
                    style="
                      display: flex;
                      height: 2.5em;
                      border-radius: 14px;
                      background-color: #e0e0e0;
                      opacity: 0.9;
                    "
                    class="mt-n4"
                  >
                    <p class="ml-2 mt-2" style="font-weight: 400">
                      Same as Sourse
                    </p>
                    <v-icon size="22" color="primary" class="mt-n1 ml-6"
                      >mdi-menu-down</v-icon
                    >
                  </div> -->
                          </div>
                          <p class="caption-11 mt-n14 ml-1">
                            Compression quality
                          </p>
                          <div class="ma-0 pa-0" style="display: flex">
                            <v-slider
                              class="mt-n3"
                              v-model="Compressionquality"
                              min="0.0"
                              step="0.1"
                              max="1.0"
                              thumb-label
                              track-color="grey"
                              track-fill-color="grey"
                            >
                            </v-slider>
                            <p
                              class="caption-11 mt-n2"
                              style="font-weight: 700; opacity: 0.8"
                            >
                              {{ computedCompressionquality }}
                              <!-- <v-btn icon>
                                <v-icon> mdi-undo </v-icon>
                              </v-btn> -->
                            </p>
                          </div>
                          <p class="caption-11 mt-n3 ml-1">Downsizing amount</p>
                          <div class="ma-0 pa-0" style="display: flex">
                            <v-slider
                              class="mt-n3"
                              v-model="Downsizingamount"
                              min="0.0"
                              step="0.1"
                              max="1.0"
                              thumb-label
                              track-color="grey"
                              track-fill-color="grey"
                            >
                            </v-slider>
                            <p
                              class="caption-11 mt-n2"
                              style="font-weight: 700; opacity: 0.8"
                            >
                              {{ computedDownsizingamount }}
                              <!-- <v-btn icon>
                                <v-icon> mdi-undo </v-icon>
                              </v-btn> -->
                            </p>
                          </div>
                          <v-card
                            elevation="0"
                            width="175"
                            height="220"
                            color="#b2ebf2"
                            rounded="xl"
                            class="mt-n4"
                            style="opacity: 0.9"
                          >
                            <div style="display: flex" class="pt-4 pl-4 pr-4">
                              <p style="font-size: 11px; font-weight: 570">
                                Texture Info
                              </p>
                              <v-spacer></v-spacer>
                              <v-icon size="24" class="mt-n2" color="black"
                                >mdi-information-outline</v-icon
                              >
                            </div>
                            <div style="display: flex" class="pl-7 pr-4">
                              <p class="caption-11">Format</p>
                              <v-spacer></v-spacer>
                              <p class="caption-11">PNG</p>
                            </div>
                            <div style="display: flex" class="pl-7 pr-4 mt-n1">
                              <p class="caption-11">Original</p>
                              <v-spacer></v-spacer>
                              <p class="caption-11">4096 px</p>
                            </div>
                            <div style="display: flex" class="pl-7 pr-4 mt-n1">
                              <p class="caption-11">Resized to</p>
                              <v-spacer></v-spacer>
                              <p style="color: #1565c0" class="caption-11">
                                1434 px
                              </p>
                            </div>
                            <v-banner
                              color="#00897B"
                              height="1"
                              dark
                              width="175"
                              style="opacity: 0.4"
                            ></v-banner>
                            <div style="display: flex" class="pl-4 pr-4 pt-2">
                              <p style="font-size: 11px; font-weight: 570">
                                File Size
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px; font-weight: 570">
                                improved
                              </p>
                              <p
                                style="
                                  font-size: 11px;
                                  font-weight: 570;
                                  color: #1565c0;
                                "
                              >
                                :33.33%
                              </p>
                            </div>
                            <div style="display: flex" class="pl-7 pr-4">
                              <p class="caption-11">Before:</p>
                              <v-spacer></v-spacer>
                              <p class="caption-11">12 mb</p>
                            </div>
                            <div style="display: flex" class="pl-7 pr-4 mt-n2">
                              <p class="caption-11">After:</p>
                              <v-spacer></v-spacer>
                              <p style="color: #1565c0" class="caption-11">
                                8 mb
                              </p>
                            </div>
                          </v-card>
                          <div
                            class="ml-2 mb-3"
                            style="
                              height: 1.6em;
                              border-radius: 23px;
                              background-color: #0277bd;
                              cursor: pointer;
                              opacity: 0.6;
                            "
                          >
                            <p style="text-align: center; color: white">
                              Apply
                            </p>
                          </div>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-container>
              </div>
              <!-- end viewer settings component -->
            </v-card>
          </div>

          <div
            class="
              md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100
            "
          >
            <md-card class="md-card-plain mt-n3 pb-14">
              <h2
                v-if="augmentableTheme"
                style="
                  color: white;
                  opacity: 0.8;
                  font-family: Nunito Sans;
                  font-size: 2rem !important;
                  font-weight: 1000 !important;
                "
              >
                Export
              </h2>
              <h2
                v-if="!augmentableTheme"
                style="
                  color: black;
                  opacity: 0.8;
                  font-family: Nunito Sans;
                  font-size: 2rem !important;
                  font-weight: 1000 !important;
                "
              >
                Export
              </h2>
              <p class="category mt-n3">
                Here you can download your 3D object in the desired format
                (select to get the expected file size)
              </p>
              <v-card
                :style="{ background: $vuetify.theme.themes[theme].background }"
                elevation="0"
                min-height="60"
                style="overflow: hidden"
                class="pl-1 mt-n3 ml-n2"
              >
                <div
                  v-for="(item, index) in computedDownloadFileItems"
                  :key="index"
                >
                  <v-row class="mb-n7">
                    <v-col cols="1">
                      <v-checkbox
                        class="mt-n1 ml-1"
                        v-model="item.checked"
                        @click="checkExportValues(item, index)"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col cols="3" class="">
                      <p
                        class="caption-11 ml-1"
                        style="font-weight: 700; opacity: 0.8"
                      >
                        {{ item.title }}
                      </p>
                    </v-col>
                    <v-col cols="1" class="">
                      <v-menu
                        v-if="item.value == 'draco'"
                        rounded="xl"
                        :close-on-content-click="false"
                        top
                        offset-y
                        min-width="220"
                      >
                        <template v-slot:activator="{ on }">
                          <div style="cursor: pointer" v-on="on" class="ml-n3">
                            <v-icon> mdi-menu-down </v-icon>
                            <!-- <v-icon @click="importmenu1 = true">
                              mdi-menu-down
                            </v-icon> -->
                          </div>
                        </template>

                        <v-card
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          elevation="0"
                          class="ma-0 pa-0 pb-2"
                          min-width="220"
                          min-height="80"
                          max-height="500"
                        >
                          <div class="ma-0 pa-0" style="display: flex">
                            <v-card
                              elevation="0"
                              color="transparent"
                              class="ma-0 pa-0"
                              min-width="220"
                              min-height="80"
                              max-height="500"
                            >
                              <v-row class="pt-2">
                                <v-col cols="1"></v-col>
                                <v-col cols="7">
                                  <p style="font-size: 11px; font-weight: 760">
                                    Optimized file settings
                                  </p>
                                </v-col>
                                <v-col cols="1">
                                  <v-icon class="mt-n1 ml-n1"
                                    >settings_input_component</v-icon
                                  >
                                </v-col>
                                <v-col cols="1"></v-col>
                              </v-row>
                              <v-row class="mt-n6">
                                <v-col cols="1"></v-col>
                                <v-col cols="6">
                                  <p style="font-size: 10px; font-weight: 660">
                                    Set File Format
                                  </p>
                                </v-col>
                                <v-col
                                  cols="1"
                                  style="cursor: pointer"
                                  @click="importmenu1 = !importmenu1"
                                >
                                  <v-icon
                                    class="ml-n7 mt-n2"
                                    v-if="!importmenu1"
                                  >
                                    mdi-menu-right
                                  </v-icon>
                                  <v-icon
                                    class="ml-n7 mt-n2"
                                    v-if="importmenu1"
                                  >
                                    mdi-menu-down
                                  </v-icon>
                                </v-col>
                              </v-row>
                              <v-row class="mt-n6">
                                <v-col cols="1"></v-col>
                                <v-col cols="6">
                                  <p style="font-size: 10px; font-weight: 660">
                                    Reduction Level
                                  </p>
                                </v-col>
                                <v-col
                                  cols="1"
                                  style="cursor: pointer"
                                  @click="importmenu1 = !importmenu1"
                                >
                                  <v-icon
                                    class="ml-n7 mt-n2"
                                    v-if="!importmenu1"
                                  >
                                    mdi-menu-right
                                  </v-icon>
                                  <v-icon
                                    class="ml-n7 mt-n2"
                                    v-if="importmenu1"
                                  >
                                    mdi-menu-down
                                  </v-icon>
                                </v-col>
                              </v-row>
                              <v-card
                                :style="{
                                  background:
                                    $vuetify.theme.themes[theme].background,
                                }"
                                v-if="importmenu1"
                                elevation="0"
                                width="180"
                                height="85"
                                class="ml-2 mr-1 mt-n4"
                              >
                                <v-row
                                  class="pa-0 ma-0 ml-3 mb-n11"
                                  v-for="(item, index) in quality"
                                  :key="index"
                                >
                                  <v-row class="pa-0 ma-0">
                                    <v-col cols="5">
                                      <p style="font-size: 11px" class="ml-n2">
                                        {{ item.title }}
                                      </p>
                                    </v-col>
                                    <v-col cols="6">
                                      <p style="font-size: 11px">
                                        <v-icon
                                          style="margin-top: -0.1em"
                                          @click="minquality(item)"
                                          >navigate_before</v-icon
                                        >{{ item.value
                                        }}<v-icon
                                          style="margin-top: -0.1em"
                                          @click="maxquality(item)"
                                          >navigate_next</v-icon
                                        >
                                      </p>
                                    </v-col>
                                    <v-col cols="1" class="mt-n6 ml-n4">
                                      <v-checkbox
                                        class="ml-n3"
                                        v-model="item.checked"
                                        @click="checkQualityValues(item)"
                                      ></v-checkbox>
                                    </v-col>
                                  </v-row>
                                </v-row>
                              </v-card>
                              <v-row class="mt-n6">
                                <v-col cols="7">
                                  <p
                                    class="ml-6"
                                    style="font-size: 10px; font-weight: 660"
                                  >
                                    Set Compression
                                  </p>
                                </v-col>
                                <v-col
                                  cols="1"
                                  style="cursor: pointer"
                                  @click="importmenu2 = !importmenu2"
                                >
                                  <v-icon
                                    class="ml-n6 mt-n2"
                                    v-if="!importmenu2"
                                  >
                                    mdi-menu-right
                                  </v-icon>
                                  <v-icon
                                    class="ml-n6 mt-n2"
                                    v-if="importmenu2"
                                  >
                                    mdi-menu-down
                                  </v-icon>
                                </v-col>
                                <v-col cols="1">
                                  <md-icon
                                    v-if="augmentableTheme"
                                    class="md-size-x ml-n2 mt-n1"
                                    md-src="/static/assets/svg/white/dracoIcon.svg"
                                  />
                                  <md-icon
                                    v-if="!augmentableTheme"
                                    class="md-size-x ml-n2 mt-n1"
                                    md-src="/static/assets/svg/black/dracoIcon.svg"
                                  />
                                </v-col>
                                <v-col
                                  cols="1"
                                  class="mr-2"
                                  style="cursor: pointer"
                                >
                                  <v-icon
                                    class="mt-n2 ml-n3"
                                    @click="importmenu3 = !importmenu3"
                                  >
                                    mdi-menu-right</v-icon
                                  >
                                </v-col>
                              </v-row>

                              <v-card
                                :style="{
                                  background:
                                    $vuetify.theme.themes[theme].background,
                                }"
                                v-if="importmenu2"
                                elevation="0"
                                width="190"
                                min-height="80"
                                class="ml-2 pr-1 mt-n3"
                              >
                                <div style="display: flex">
                                  <p style="font-size: 11px" class="ml-4">
                                    No Draco
                                  </p>
                                  <v-spacer></v-spacer>
                                  <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                                </div>
                                <div style="display: flex" class="mt-n5">
                                  <p style="font-size: 11px" class="ml-4">
                                    UV's
                                  </p>
                                  <v-spacer></v-spacer>
                                  <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                                </div>

                                <div style="display: flex" class="mt-n5">
                                  <p style="font-size: 11px" class="ml-4">
                                    Vertex Colors
                                  </p>
                                  <v-spacer></v-spacer>
                                  <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                                </div>
                                <v-row class="mt-n8">
                                  <v-col cols="5">
                                    <p style="font-size: 11px" class="ml-4">
                                      Materials
                                    </p>
                                  </v-col>
                                  <v-col cols="4">
                                    <v-icon
                                      class="mt-n2"
                                      @click="
                                        materialtexture = !materialtexture
                                      "
                                      >mdi-menu-down</v-icon
                                    >
                                  </v-col>
                                  <v-col cols="1">
                                    <v-checkbox
                                      class="mt-n2 ml-n2"
                                    ></v-checkbox>
                                  </v-col>
                                  <v-col cols="1"> </v-col>
                                </v-row>
                                <div
                                  v-if="materialtexture"
                                  class="ma-0 pa-0 mt-n6 ml-4"
                                >
                                  <p
                                    style="font-size: 10px; font-weight: 450"
                                    class="ml-2"
                                  >
                                    Texture Format
                                  </p>
                                  <v-select
                                    rounded
                                    outlined
                                    dense
                                    label="Same as Sourse"
                                    class="mt-n3"
                                    :item="textureitem"
                                  >
                                  </v-select>
                                  <!-- <div
                    style="
                      display: flex;
                      height: 2.5em;
                      border-radius: 14px;
                      background-color: #e0e0e0;
                      opacity: 0.9;
                    "
                    class="mt-n4"
                  >
                    <p class="ml-2 mt-2" style="font-weight: 400">
                      Same as Sourse
                    </p>
                    <v-icon size="22" color="primary" class="mt-n1 ml-6"
                      >mdi-menu-down</v-icon
                    >
                  </div> -->
                                </div>
                                <!-- <v-card
                                  v-if="materialtexture"
                                  elevation="0"
                                  color="transparent"
                                  min-width="120"
                                  min-height="100"
                                  class="ma-0 pa-0 mt-n4 ml-4"
                                >
                                  <p
                                    style="font-size: 10px; font-weight: 450"
                                    class="ml-2"
                                  >
                                    Texture
                                  </p>
                                  <div
                                    style="
                                      display: flex;
                                      height: 2.5em;
                                      border-radius: 14px;
                                      background-color: #b2ebf2;
                                      opacity: 0.9;
                                    "
                                    class="mt-n1"
                                  >
                                    <p
                                      class="ml-2 mt-2"
                                      style="font-weight: 500"
                                    >
                                      Same as Sourse
                                    </p>
                                    <v-icon
                                      size="22"
                                      color="#01579B"
                                      class="mt-n1 ml-6"
                                      >mdi-menu-down</v-icon
                                    >
                                  </div>
                                </v-card> -->
                              </v-card>
                            </v-card>
                            <v-divider
                              v-if="importmenu3"
                              vertical
                              style="border-color: #d3d3d3"
                              class="mt-3 mb-3"
                            ></v-divider>
                            <v-card
                              :style="{
                                background:
                                  $vuetify.theme.themes[theme].background,
                              }"
                              v-if="importmenu3"
                              elevation="0"
                              rounded="lg"
                              min-width="130"
                              min-height="110"
                              style="overflow: hidden"
                              class="pt-6"
                            >
                              <v-row class="mt-n7 ml-3 mb-5">
                                <p style="font-weight: 670" class="">
                                  Detail Settings
                                </p>
                              </v-row>
                              <v-row
                                v-for="(item, index) in pickcompression"
                                :key="index"
                              >
                                <v-row
                                  @click="checkExportFiles(item, index)"
                                  class="mt-n9"
                                >
                                  <v-col cols="1" class="ml-5">
                                    <md-icon
                                      v-if="augmentableTheme"
                                      class="md-size-x"
                                      style="cursor: pointer"
                                      :md-src="item.svg1"
                                    />
                                    <md-icon
                                      v-if="!augmentableTheme"
                                      class="md-size-x"
                                      style="cursor: pointer"
                                      :md-src="item.svg2"
                                    />
                                  </v-col>
                                  <v-col cols="8">
                                    <p
                                      class="caption-11 mt-1 ml-1"
                                      style="
                                        font-weight: 650;
                                        opacity: 0.8;
                                        cursor: pointer;
                                      "
                                    >
                                      {{ item.name }}
                                    </p>
                                  </v-col>
                                  <v-col cols="1">
                                    <v-checkbox
                                      class="mt-n1 ml-n7"
                                    ></v-checkbox>
                                  </v-col>
                                  <v-col cols="1"> </v-col>
                                </v-row>
                              </v-row>
                              <div style="display: flex" class="mt-n4">
                                <p style="font-size: 11px" class="ml-3">
                                  Compression Level
                                </p>
                                <v-spacer></v-spacer>
                                <p style="font-size: 11px" class="mt-n1 mr-3">
                                  <v-icon style="margin-top: -0.1em"
                                    >navigate_before</v-icon
                                  >8<v-icon style="margin-top: -0.1em"
                                    >navigate_next</v-icon
                                  >
                                </p>
                              </div>

                              <div style="display: flex" class="mt-n1">
                                <p style="font-size: 11px" class="ml-3">
                                  Quantize position
                                </p>
                                <v-spacer></v-spacer>
                                <p style="font-size: 11px" class="mt-n1 mr-3">
                                  <v-icon style="margin-top: -0.1em"
                                    >navigate_before</v-icon
                                  >8<v-icon style="margin-top: -0.1em"
                                    >navigate_next</v-icon
                                  >
                                </p>
                              </div>

                              <div style="display: flex" class="mt-n1">
                                <p style="font-size: 11px" class="ml-3">
                                  Normals
                                </p>
                                <v-spacer></v-spacer>
                                <p style="font-size: 11px" class="mt-n1 mr-3">
                                  <v-icon style="margin-top: -0.1em"
                                    >navigate_before</v-icon
                                  >8<v-icon style="margin-top: -0.1em"
                                    >navigate_next</v-icon
                                  >
                                </p>
                              </div>

                              <div style="display: flex" class="mt-n1">
                                <p style="font-size: 11px" class="ml-3">
                                  Tex Coord
                                </p>
                                <v-spacer></v-spacer>
                                <p style="font-size: 11px" class="mt-n1 mr-3">
                                  <v-icon style="margin-top: -0.1em"
                                    >navigate_before</v-icon
                                  >8<v-icon style="margin-top: -0.1em"
                                    >navigate_next</v-icon
                                  >
                                </p>
                              </div>

                              <div style="display: flex" class="mt-n1">
                                <p style="font-size: 11px" class="ml-3">
                                  Generic
                                </p>
                                <v-spacer></v-spacer>
                                <p style="font-size: 11px" class="mt-n1 mr-3">
                                  <v-icon style="margin-top: -0.1em"
                                    >navigate_before</v-icon
                                  >8<v-icon style="margin-top: -0.1em"
                                    >navigate_next</v-icon
                                  >
                                </p>
                              </div>
                            </v-card>
                          </div>
                          <!-- <v-row class="mt-7 ml-2 mb-n1">
                                <h5
                                  style="
                                    color: blue;
                                    text-align: center;
                                    font-weight: 600;
                                  "
                                >
                                  Select
                                </h5>
                              </v-row>
                              <div
                                class="ml-2 mt-2 mb-3"
                                v-for="(item, index) in pickcompression"
                                :key="index"
                              >
                                <div style="display: flex" class="mb-n7">
                                  <p style="font-size: 10px; font-weight: 670">
                                    {{ item.title }}
                                  </p>
                                  <v-spacer></v-spacer>
                                  <v-checkbox class="mt-n2"></v-checkbox>
                                </div>
                              </div> -->
                          <!-- <v-row class="pt-2">
                            <v-col cols="1"></v-col>
                            <v-col cols="6">
                              <p style="font-size: 10px; font-weight: 660">
                                Set Compression
                              </p>
                            </v-col>
                            <v-col
                              cols="1"
                              style="cursor: pointer"
                              @click="importmenu1 = !importmenu1"
                            >
                              <v-icon class="ml-n4 mt-n2" v-if="!importmenu1">
                                mdi-menu-right
                              </v-icon>
                              <v-icon class="ml-n4 mt-n2" v-if="importmenu1">
                                mdi-menu-down
                              </v-icon>
                            </v-col>
                            <v-col cols="1">
                              <v-icon class="mt-n1 ml-n1"
                                >settings_input_component</v-icon
                              >
                            </v-col>
                            <v-col cols="1"></v-col>
                          </v-row>
                          <v-card
                            :style="{
                              background:
                                $vuetify.theme.themes[theme].background,
                            }"
                            v-if="importmenu1"
                            elevation="0"
                            width="180"
                            height="85"
                            class="ml-2 mr-1 mt-n4"
                          >
                            <v-row
                              class="pa-0 ma-0 ml-3 mb-n11"
                              v-for="(item, index) in quality"
                              :key="index"
                            >
                              <v-row class="pa-0 ma-0">
                                <v-col cols="5">
                                  <p style="font-size: 11px" class="ml-n2">
                                    {{ item.title }}
                                  </p>
                                </v-col>
                                <v-col cols="6">
                                  <p style="font-size: 11px">
                                    <v-icon
                                      style="margin-top: -0.1em"
                                      @click="minquality(item)"
                                      >navigate_before</v-icon
                                    >{{ item.value
                                    }}<v-icon
                                      style="margin-top: -0.1em"
                                      @click="maxquality(item)"
                                      >navigate_next</v-icon
                                    >
                                  </p>
                                </v-col>
                                <v-col cols="1" class="mt-n6 ml-n4">
                                  <v-checkbox
                                    class="ml-n3"
                                    v-model="item.checked"
                                    @click="checkQualityValues(item)"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-row>
                          </v-card>
                          <v-row class="mt-n4">
                            <v-col cols="7">
                              <p
                                class="ml-6"
                                style="font-size: 10px; font-weight: 660"
                              >
                                Pick Compression
                              </p>
                            </v-col>
                            <v-col
                              cols="1"
                              style="cursor: pointer"
                              @click="importmenu2 = !importmenu2"
                            >
                              <v-icon class="ml-n6 mt-n2" v-if="!importmenu2">
                                mdi-menu-right
                              </v-icon>
                              <v-icon class="ml-n6 mt-n2" v-if="importmenu2">
                                mdi-menu-down
                              </v-icon>
                            </v-col>
                            <v-col cols="1">
                              <md-icon
                                v-if="augmentableTheme"
                                class="md-size-x ml-n7 mt-n1"
                                md-src="/static/assets/svg/white/dracoIcon.svg"
                              />
                              <md-icon
                                v-if="!augmentableTheme"
                                class="md-size-x ml-n7 mt-n1"
                                md-src="/static/assets/svg/black/dracoIcon.svg"
                              />
                            </v-col>
                            <v-col
                              cols="1"
                              class="mr-2"
                              style="cursor: pointer"
                            >
                              <v-menu
                                rounded="lg"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                top
                                max-width="130"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-icon class="mt-n2 ml-n5" v-on="on">
                                    mdi-menu-right</v-icon
                                  >
                                </template>
                                <v-card
                                  :style="{
                                    background:
                                      $vuetify.theme.themes[theme].background,
                                  }"
                                  elevation="0"
                                  rounded="lg"
                                  width="130"
                                  height="76"
                                  style="overflow: hidden"
                                  class="ma-0 pa-0"
                                >
                                  <div
                                    class="ml-2 mt-2"
                                    v-for="(item, index) in pickcompression"
                                    :key="index"
                                  >
                                    <div style="display: flex" class="mb-n7">
                                      <p
                                        style="
                                          font-size: 10px;
                                          font-weight: 670;
                                        "
                                      >
                                        {{ item.title }}
                                      </p>
                                      <v-spacer></v-spacer>
                                      <v-checkbox class="mt-n2"></v-checkbox>
                                    </div>
                                  </div>
                                </v-card>
                              </v-menu>
                            </v-col>
                          </v-row>
                          <v-card
                            :style="{
                              background:
                                $vuetify.theme.themes[theme].background,
                            }"
                            v-if="importmenu2"
                            elevation="0"
                            width="190"
                            min-height="150"
                            class="ml-2 pr-1 mt-n3"
                          >
                            <div style="display: flex">
                              <p style="font-size: 11px" class="ml-4">UV's</p>
                              <v-spacer></v-spacer>
                              <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                            </div>

                            <div style="display: flex" class="mt-n5">
                              <p style="font-size: 11px" class="ml-4">
                                Vertex Colors
                              </p>
                              <v-spacer></v-spacer>
                              <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                            </div>

                            <div style="display: flex" class="mt-n5">
                              <p style="font-size: 11px" class="ml-4">
                                Materials
                              </p>
                              <v-spacer></v-spacer>
                              <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                            </div>

                            <div style="display: flex" class="mt-n5">
                              <p style="font-size: 11px" class="ml-4">
                                Compression Level
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px" class="mt-n1">
                                <v-icon style="margin-top: -0.1em"
                                  >navigate_before</v-icon
                                >8<v-icon style="margin-top: -0.1em"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </div>

                            <div style="display: flex" class="mt-n1">
                              <p style="font-size: 11px" class="ml-4">
                                Quantize position
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px" class="mt-n1">
                                <v-icon style="margin-top: -0.1em"
                                  >navigate_before</v-icon
                                >8<v-icon style="margin-top: -0.1em"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </div>

                            <div style="display: flex" class="mt-n1">
                              <p style="font-size: 11px" class="ml-4">
                                Normals
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px" class="mt-n1">
                                <v-icon style="margin-top: -0.1em"
                                  >navigate_before</v-icon
                                >8<v-icon style="margin-top: -0.1em"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </div>

                            <div style="display: flex" class="mt-n1">
                              <p style="font-size: 11px" class="ml-4">
                                Tex Coord
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px" class="mt-n1">
                                <v-icon style="margin-top: -0.1em"
                                  >navigate_before</v-icon
                                >8<v-icon style="margin-top: -0.1em"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </div>

                            <div style="display: flex" class="mt-n1">
                              <p style="font-size: 11px" class="ml-4">
                                Generic
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px" class="mt-n1">
                                <v-icon style="margin-top: -0.1em"
                                  >navigate_before</v-icon
                                >8<v-icon style="margin-top: -0.1em"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </div>
                          </v-card> -->
                        </v-card>
                      </v-menu>
                    </v-col>
                    <v-col cols="2" class="ml-n4">
                      <p
                        class="caption-11"
                        style="font-weight: 700; opacity: 0.8"
                        v-if="item.value === 'glb'"
                      >
                        {{ sizeDownloadGLB }}
                      </p>
                      <p
                        class="caption-11"
                        style="font-weight: 700; opacity: 0.8"
                        v-if="item.value === 'gltf'"
                      >
                        {{ sizeDownloadGLTF }}
                      </p>
                      <p
                        class="caption-11"
                        style="font-weight: 700; opacity: 0.8"
                        v-if="item.value == 'draco'"
                      >
                        {{ compressionSetting.title }}
                      </p>
                    </v-col>
                    <v-col cols="1" class="ml-6">
                      <div style="display: flex">
                        <md-icon
                          v-if="augmentableTheme && item.value == 'draco'"
                          class="md-size-x ml-n7"
                          md-src="/static/assets/svg/white/dracoIcon.svg"
                        />
                        <md-icon
                          v-if="!augmentableTheme && item.value == 'draco'"
                          class="md-size-x ml-n7"
                          md-src="/static/assets/svg/black/dracoIcon.svg"
                        />
                        <v-icon class="ml-3" v-if="item.value == 'draco'"
                          >settings_input_component</v-icon
                        >
                      </div>
                    </v-col>
                    <v-col cols="4" class="ml-2 mr-n9">
                      <p
                        class="caption-11 mt-1 ml-15"
                        style="font-weight: 700; opacity: 0.8"
                      >
                        {{ item.size }}
                      </p>
                      <p
                        class="caption-11 mt-n2"
                        style="font-weight: 700; opacity: 0.8"
                        v-if="!item.size"
                      >
                        {{ item.titledetail }}
                      </p>
                    </v-col>
                  </v-row>
                </div>
              </v-card>

              <!-- <div class="mt-n6 ml-n4">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-checkbox
                      style="margin-left: 15px"
                      id="cbox11"
                      v-model="originalGLBfile"
                      label="Original GLB File"
                      v-on="on"
                    >
                      <template v-slot:label>
                        <div class="row">
                          <div class="col-6">Original File</div>

                          <div class="col-6">
                            {{ file.filesize }}
                          </div>
                        </div>
                      </template>
                    </v-checkbox>
                  </template>
                  <span
                    >you can select more options and download the asset in the
                    chosen formats
                  </span>
                </v-tooltip>
              </div>
              <div class="mt-n13 ml-n4" v-if="glbDown">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-checkbox
                      style="margin-left: 15px"
                      id="cbox11"
                      v-model="downloadGLB"
                      label="GLB File"
                      v-on="on"
                    >
                      <template v-slot:label>
                        <div class="row">
                          <div class="col-6">GLB (from Viewer)</div>

                          <div class="col-6">
                            <strong>{{ sizeDownloadGLB }}</strong>
                          </div>
                        </div>
                      </template>
                    </v-checkbox>
                  </template>
                  <span
                    >you can select more options and download the asset in the
                    chosen formats
                  </span>
                </v-tooltip>
              </div>
              <div class="mt-n13 ml-n4" v-if="gltfDown">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-checkbox
                      style="margin-left: 15px"
                      id="cbox11"
                      v-model="downloadGLTF"
                      label="GLTF File"
                      v-on="on"
                    >
                      <template v-slot:label>
                        <div class="row">
                          <div class="col-6">GLTF (from Viewer)</div>

                          <div class="col-6">
                            <strong>{{ sizeDownloadGLTF }}</strong>
                          </div>
                        </div>
                      </template>
                    </v-checkbox>
                  </template>
                  <span
                    >you can select more options and download the asset in the
                    chosen formats
                  </span>
                </v-tooltip>
              </div>
              <div class="mt-n13 ml-n4" v-if="usdDown">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-checkbox
                      style="margin-left: 15px"
                      id="cbox11"
                      v-model="downloadUSD"
                      label="USD File"
                      v-on="on"
                    >
                      <template v-slot:label>
                        <div class="row">
                          <div class="col-6">USD (from Viewer)</div>

                          <div class="col-6">
                            <strong>{{ sizeDownloadUSD }}</strong>
                          </div>
                        </div>
                      </template>
                    </v-checkbox>
                  </template>
                  <span
                    >you can select more options and download the asset in the
                    chosen formats
                  </span>
                </v-tooltip>
              </div>
              <div class="mt-n13 ml-n4" v-if="usdzDown">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-checkbox
                      style="margin-left: 15px"
                      id="cbox11"
                      v-model="downloadUSDZ"
                      label="USDZ File"
                      v-on="on"
                    >
                      <template v-slot:label>
                        <div class="row">
                          <div class="col-6">USDZ (from Viewer)</div>

                          <div class="col-6">
                            <strong>{{ sizeDownloadUSDZ }}</strong>
                          </div>
                        </div>
                      </template>
                    </v-checkbox>
                  </template>
                  <span
                    >you can select more options and download the asset in the
                    chosen formats
                  </span>
                </v-tooltip>
              </div>

              <v-card
                v-if="compressed"
                :style="{ background: $vuetify.theme.themes[theme].background }"
                elevation="0"
                min-height="60"
                style="overflow: hidden"
                class="pl-1 mt-n6 ml-n2"
              >
                <div v-for="(item, index) in importFileItems" :key="index">
                  <v-row class="mb-n7">
                    <v-col cols="1">
                      <v-checkbox
                        class="mt-n1 ml-1"
                        v-model="item.checked"
                        @click="checkImportValues(item)"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col cols="3" class="">
                      <p
                        class="caption-11 ml-1"
                        style="font-weight: 700; opacity: 0.8"
                      >
                        {{ item.title }}
                      </p>
                    </v-col>
                    <v-col cols="1" class="">
                      <v-menu
                        v-if="item.value == 'draco'"
                        rounded="xl"
                        :close-on-content-click="false"
                        top
                        offset-y
                        max-width="210"
                      >
                        <template v-slot:activator="{ on }">
                          <div style="cursor: pointer" v-on="on" class="ml-n3">
                            <v-icon @click="importmenu1 = true">
                              mdi-menu-down
                            </v-icon>
                          </div>
                        </template>
                        <v-card
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          elevation="0"
                          class="ma-0 pa-0 pb-2"
                          width="220"
                          min-height="80"
                          max-height="500"
                        >
                          <v-row class="pt-2">
                            <v-col cols="1"></v-col>
                            <v-col cols="6">
                              <p style="font-size: 10px; font-weight: 660">
                                Set Compression
                              </p>
                            </v-col>
                            <v-col
                              cols="1"
                              style="cursor: pointer"
                              @click="importmenu1 = !importmenu1"
                            >
                              <v-icon class="ml-n4 mt-n2" v-if="!importmenu1">
                                mdi-menu-right
                              </v-icon>
                              <v-icon class="ml-n4 mt-n2" v-if="importmenu1">
                                mdi-menu-down
                              </v-icon>
                            </v-col>
                            <v-col cols="1">
                              <v-icon class="mt-n1 ml-n1"
                                >settings_input_component</v-icon
                              >
                            </v-col>
                            <v-col cols="1"></v-col>
                          </v-row>
                          <v-card
                            :style="{
                              background:
                                $vuetify.theme.themes[theme].background,
                            }"
                            v-if="importmenu1"
                            elevation="0"
                            width="180"
                            height="85"
                            class="ml-2 mr-1 mt-n4"
                          >
                            <v-row
                              class="pa-0 ma-0 ml-3 mb-n11"
                              v-for="(item, index) in quality"
                              :key="index"
                            >
                              <v-row class="pa-0 ma-0">
                                <v-col cols="5">
                                  <p style="font-size: 11px" class="ml-n2">
                                    {{ item.title }}
                                  </p>
                                </v-col>
                                <v-col cols="6">
                                  <p style="font-size: 11px">
                                    <v-icon
                                      style="margin-top: -0.1em"
                                      @click="minquality(item)"
                                      >navigate_before</v-icon
                                    >{{ item.value
                                    }}<v-icon
                                      style="margin-top: -0.1em"
                                      @click="maxquality(item)"
                                      >navigate_next</v-icon
                                    >
                                  </p>
                                </v-col>
                                <v-col cols="1" class="mt-n6 ml-n4">
                                  <v-checkbox
                                    class="ml-n3"
                                    v-model="item.checked"
                                    @click="checkQualityValues(item)"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-row>
                          </v-card>
                          <v-row class="mt-n4">
                            <v-col cols="7">
                              <p
                                class="ml-6"
                                style="font-size: 10px; font-weight: 660"
                              >
                                Pick Compression
                              </p>
                            </v-col>
                            <v-col
                              cols="1"
                              style="cursor: pointer"
                              @click="importmenu2 = !importmenu2"
                            >
                              <v-icon class="ml-n6 mt-n2" v-if="!importmenu2">
                                mdi-menu-right
                              </v-icon>
                              <v-icon class="ml-n6 mt-n2" v-if="importmenu2">
                                mdi-menu-down
                              </v-icon>
                            </v-col>
                            <v-col cols="1">
                              <md-icon
                                v-if="augmentableTheme"
                                class="md-size-x ml-n7 mt-n1"
                                md-src="/static/assets/svg/white/dracoIcon.svg"
                              />
                              <md-icon
                                v-if="!augmentableTheme"
                                class="md-size-x ml-n7 mt-n1"
                                md-src="/static/assets/svg/black/dracoIcon.svg"
                              />
                            </v-col>
                            <v-col
                              cols="1"
                              class="mr-2"
                              style="cursor: pointer"
                            >
                              <v-menu
                                rounded="lg"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                top
                                max-width="130"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-icon class="mt-n2 ml-n5" v-on="on">
                                    mdi-menu-right</v-icon
                                  >
                                </template>
                                <v-card
                                  :style="{
                                    background:
                                      $vuetify.theme.themes[theme].background,
                                  }"
                                  elevation="0"
                                  rounded="lg"
                                  width="130"
                                  height="76"
                                  style="overflow: hidden"
                                  class="ma-0 pa-0"
                                >
                                  <div
                                    class="ml-2 mt-2"
                                    v-for="(item, index) in pickcompression"
                                    :key="index"
                                  >
                                    <div style="display: flex" class="mb-n7">
                                      <p
                                        style="
                                          font-size: 10px;
                                          font-weight: 670;
                                        "
                                      >
                                        {{ item.title }}
                                      </p>
                                      <v-spacer></v-spacer>
                                      <v-checkbox class="mt-n2"></v-checkbox>
                                    </div>
                                  </div>
                                </v-card>
                              </v-menu>
                            </v-col>
                          </v-row>
                          <v-card
                            :style="{
                              background:
                                $vuetify.theme.themes[theme].background,
                            }"
                            v-if="importmenu2"
                            elevation="0"
                            width="190"
                            min-height="150"
                            class="ml-2 pr-1 mt-n3"
                          >
                            <div style="display: flex">
                              <p style="font-size: 11px" class="ml-4">UV's</p>
                              <v-spacer></v-spacer>
                              <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                            </div>

                            <div style="display: flex" class="mt-n5">
                              <p style="font-size: 11px" class="ml-4">
                                Vertex Colors
                              </p>
                              <v-spacer></v-spacer>
                              <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                            </div>

                            <div style="display: flex" class="mt-n5">
                              <p style="font-size: 11px" class="ml-4">
                                Materials
                              </p>
                              <v-spacer></v-spacer>
                              <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                            </div>

                            <div style="display: flex" class="mt-n5">
                              <p style="font-size: 11px" class="ml-4">
                                Compression Level
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px" class="mt-n1">
                                <v-icon style="margin-top: -0.1em"
                                  >navigate_before</v-icon
                                >8<v-icon style="margin-top: -0.1em"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </div>

                            <div style="display: flex" class="mt-n1">
                              <p style="font-size: 11px" class="ml-4">
                                Quantize position
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px" class="mt-n1">
                                <v-icon style="margin-top: -0.1em"
                                  >navigate_before</v-icon
                                >8<v-icon style="margin-top: -0.1em"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </div>

                            <div style="display: flex" class="mt-n1">
                              <p style="font-size: 11px" class="ml-4">
                                Normals
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px" class="mt-n1">
                                <v-icon style="margin-top: -0.1em"
                                  >navigate_before</v-icon
                                >8<v-icon style="margin-top: -0.1em"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </div>

                            <div style="display: flex" class="mt-n1">
                              <p style="font-size: 11px" class="ml-4">
                                Tex Coord
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px" class="mt-n1">
                                <v-icon style="margin-top: -0.1em"
                                  >navigate_before</v-icon
                                >8<v-icon style="margin-top: -0.1em"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </div>

                            <div style="display: flex" class="mt-n1">
                              <p style="font-size: 11px" class="ml-4">
                                Generic
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px" class="mt-n1">
                                <v-icon style="margin-top: -0.1em"
                                  >navigate_before</v-icon
                                >8<v-icon style="margin-top: -0.1em"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </div>
                          </v-card>
                        </v-card>
                      </v-menu>
                    </v-col>
                    <v-col cols="2" class="ml-n4">
                      <p
                        class="caption-11"
                        style="font-weight: 700; opacity: 0.8"
                        v-if="item.value == 'draco'"
                      >
                        {{ compressionSetting.title }}
                      </p>
                    </v-col>
                    <v-col cols="1" class="ml-6">
                      <div style="display: flex">
                        <md-icon
                          v-if="augmentableTheme && item.value == 'draco'"
                          class="md-size-x ml-n7"
                          md-src="/static/assets/svg/white/dracoIcon.svg"
                        />
                        <md-icon
                          v-if="!augmentableTheme && item.value == 'draco'"
                          class="md-size-x ml-n7"
                          md-src="/static/assets/svg/black/dracoIcon.svg"
                        />
                        <v-icon class="ml-3" v-if="item.value == 'draco'"
                          >settings_input_component</v-icon
                        >
                      </div>
                    </v-col>
                    <v-col cols="4" class="ml-2 mr-n9">
                      <p
                        class="caption-11 mt-1 ml-15"
                        style="font-weight: 700; opacity: 0.8"
                      >
                        {{ item.size }}
                      </p>
                      <p
                        class="caption-11 mt-n2"
                        style="font-weight: 700; opacity: 0.8"
                        v-if="!item.size"
                      >
                        {{ item.titledetail }}
                      </p>
                    </v-col>
                  </v-row>
                </div>
              </v-card> -->

              <div
                class="pa-0"
                :style="{
                  background: $vuetify.theme.themes[theme].background,
                }"
              >
                <v-row justify="center">
                  <v-btn
                    v-if="augmentableTheme"
                    @click="downloadFiles()"
                    icon
                    x-large
                  >
                    <md-icon
                      class="md-size-2x"
                      md-src="/static/assets/svg/white/Download.svg"
                    ></md-icon>
                  </v-btn>
                  <v-btn
                    v-if="!augmentableTheme"
                    @click="downloadFiles()"
                    icon
                    x-large
                  >
                    <md-icon
                      class="md-size-2x"
                      md-src="/static/assets/svg/black/Download.svg"
                    ></md-icon>
                  </v-btn>
                </v-row>
              </div>
            </md-card>
          </div>
        </div>
      </div>
    </div>
    <v-overlay :value="overlayP1">
      <v-progress-circular v-bind="spinnerProps"
        ><div>QR Image</div></v-progress-circular
      >
    </v-overlay>

    <!-- <div>
      <v-btn text @click="checkAddModelToScene()">push for three</v-btn>
    </div>
    <div id="container"></div> -->
  </div>
</template>

<script>
//import EditProfileForm from "./UserProfile/EditProfileForm";
//import UserCard from "./UserProfile/UserCard";

//import vue2Dropzone from "vue2-dropzone";
//import "vue2-dropzone/dist/vue2Dropzone.min.css";

//import "../assets/scss/material-dashboard.scss";
import manageTag from "../components/manageTag";

import { ModelViewerElement } from "@google/model-viewer/dist/model-viewer.js";

import { showAt, hideAt } from "vue-breakpoints";

import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

import QrcodeVue from "qrcode.vue";

import store from "../store";
import { mapState } from "vuex";

import * as htmlToImage from "html-to-image";
import { saveAs } from "file-saver";
//import { files } from "jszip";

import * as THREE from "three/build/three.module.js";

//import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader";
//import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
//import { MTLLoader } from "three/examples/jsm/loaders/MTLLoader";

//import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

//import { BufferGeometryUtils } from "three/examples/jsm/utils/BufferGeometryUtils.js";

//import { TeapotGeometry } from "three/examples/jsm/geometries/TeapotGeometry.js";

export default {
  components: {
    manageTag,
    //EditProfileForm,
    //UserCard,
    hideAt,
    showAt,
    //vueDropzone: vue2Dropzone,
    QrcodeVue,
  },
  props: {
    file1: Object,
  },
  data: function () {
    return {
      slug: this.$route.params.slug,
      showCloseChip: null,
      Compressionquality: "0.0",
      computedCompressionquality: "0.0",
      Downsizingamount: "0.0",
      computedDownsizingamount: "0.0",
      materialtexture: false,
      photomaterialtexture: false,
      showQrCode: false,
      overlayP1: false,
      spinnerProps: {
        color: "primary",
        value: 100,
        indeterminate: true,
        size: 80,
      },
      description: true,
      descriptionEdit: false,
      localTags: [],
      searchTag: "",
      serverTags: "",
      progress: false,
      status: true,
      tagsonoff: true,
      sharelink: true,
      versions: true,
      colors: false,
      lightTheme: false,
      darkTheme: false,
      importmenu1: false,
      importmenu2: false,
      importmenu3: false,
      localStatus: [
        { title: "unProcessed", value: false },
        { title: "inProgress", value: false },
        { title: "completed", value: false },
      ],
      pickcompression: [
        {
          name: "No Draco (huge files)",
          checked: false,
          svg1: "/static/assets/svg/white/draco.svg",
          svg2: "/static/assets/svg/black/dracoIcon.svg",
        },
        {
          name: "USD (.usd)",
          checked: false,
          svg1: "/static/assets/svg/white/usd.svg",
          svg2: "/static/assets/svg/black/USDIcon.svg",
        },
        {
          name: "USDZ (.usdz)",
          checked: false,
          svg1: "/static/assets/svg/white/usdz.svg",
          svg2: "/static/assets/svg/black/USDZIcon.svg",
        },
        {
          name: "GLTF (.gltf)",
          checked: false,
          svg1: "/static/assets/svg/white/gltf.svg",
          svg2: "/static/assets/svg/black/USDZIcon.svg",
        },
        {
          name: "GLB (.glb)",
          checked: false,
          svg1: "/static/assets/svg/white/glb.svg",
          svg2: "/static/assets/svg/black/USDZIcon.svg",
        },
      ],
      // pickcompression: [
      //   { title: "USDZ" },
      //   { title: "Draco" },
      //   { title: "Combined" },
      // ],
      quality: [
        { title: "low", minValue: 0, maxValue: 9, value: 2, checked: false },
        { title: "medium", minValue: 0, maxValue: 9, value: 2, checked: false },
        { title: "high", minValue: 0, maxValue: 9, value: 8, checked: true },
      ],
      compressionSetting: {
        title: "high",
        value: 10,
      },
      textureitem: ["Same as Sourse", "JPEG"],
      localitem: [
        {
          avatarcolor: "red",
          filepng: "/static/assets/images/screenshot.png",
          picheading: "V01",
          date: "03.01.2021",
          statusbanner: true,
          statusicon: true,
          statussmallicon: false,
          statusheadingcheck: true,
          statusheading: "unprocessed",
          progressbanner: true,
          progressicon: true,
          progressheadingcheck: true,
          progressheading: "texture optimized",
          datecheck: true,
        },
        {
          avatarcolor: "grey",
          filepng: "/static/assets/images/screenshot(1).png",
          picheading: "V02",
          date: "06.01.2021",
          statusbanner: true,
          statusicon: true,
          statussmallicon: true,
          statusheadingcheck: true,
          statusheading: "in complete",
          progressbanner: true,
          progressicon: true,
          progressheadingcheck: true,
          progressheading: "color change",
          datecheck: true,
        },
        {
          avatarcolor: "orange",
          filepng: "/static/assets/images/screenshot(2).png",
          picheading: "V03",
          date: "09.01.2021",
          statusbanner: false,
          statusicon: true,
          statussmallicon: false,
          statusheadingcheck: true,
          statusheading: "completed",
          progressbanner: true,
          progressicon: true,
          progressheadingcheck: true,
          progressheading: "material change",
          datecheck: true,
        },
        {
          avatarcolor: "purple",
          filepng: "/static/assets/images/screenshot.png",
          picheading: "V01",
          date: "12.01.2021",
          statusbanner: false,
          statusicon: false,
          statussmallicon: false,
          statusheadingcheck: false,
          progressbanner: true,
          progressicon: true,
          progressheadingcheck: true,
          progressheading: "texture optimized",
          datecheck: true,
        },
        {
          avatarcolor: "#00bfff",
          filepng: "/static/assets/images/screenshot(1).png",
          picheading: "V02",
          date: "14.01.2021",
          statusbanner: false,
          statusicon: false,
          statussmallicon: false,
          statusheadingcheck: false,
          progressbanner: false,
          progressicon: false,
          progressheadingcheck: false,
          datecheck: false,
        },
      ],
      shareLink: "",
      filePassword: "",
      dropOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        //maxFilesize: 0.5,
        maxFiles: 1,
      },
      // downloadFileItems: [
      //   { title: "Original GLB File", value: false },
      //   { title: "GLB File", value: false, valueMax: "", max: "2048" },
      //   { title: "GLTF File", value: false, valueMax: "", max: "2048" },
      //   //{ title: "USDZ File", value: false },
      // ],
      filebtns: [
        {
          name: "Original File",
          checked: false,
        },
        {
          name: "GLB",
          checked: false,
          svg1: "/static/assets/svg/white/glb.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
        },
        {
          name: "Draco GLB",
          checked: false,
          svg1: "/static/assets/svg/white/glb.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
        },
        {
          name: "Draco GLTF",
          checked: false,
          svg1: "/static/assets/svg/white/gltf.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
          // svg1: "/static/assets/svg/white/dracoIcon.svg",
          // svg2: "/static/assets/svg/black/dracoIcon.svg",
        },

        // {
        //   name: "Draco",
        //   checked: true,
        //   svg1: "/static/assets/svg/white/GLBIcon.svg",
        //   svg2: "/static/assets/svg/black/GLBIcon.svg",
        // },
        {
          name: "USD",
          checked: false,
          svg1: "/static/assets/svg/white/usd.svg",
          svg2: "/static/assets/svg/black/USDIcon.svg",
        },
        {
          name: "USDZ",
          checked: false,
          svg1: "/static/assets/svg/white/usdz.svg",
          svg2: "/static/assets/svg/black/USDZIcon.svg",
        },
      ],
      downloadFileItems: [
        {
          title: "Original File",
          value: "original",
          valueMax: "",
          max: "2048",
          size: "",
          checked: true,
          list: true,
        },
        {
          title: "Optimized File",
          value: "draco",
          color: "orange",
          checked: false,
          list: true,
        },
        {
          title: "GLB File",
          value: "glb",
          valueMax: "",
          max: "2048",
          size: "",
          checked: false,
          list: false,
        },
        {
          title: "GLB File",
          value: "glb",
          valueMax: "",
          max: "2048",
          size: "",
          checked: false,
          list: false,
        },
        {
          title: "GLTF File",
          value: "gltf",
          valueMax: "",
          max: "2048",
          size: "",
          checked: false,
          list: false,
        },

        {
          title: "USD File",
          value: "usd",
          valueMax: "",
          max: "2048",
          size: "",
          checked: false,
          list: false,
        },
        {
          title: "USDZ File",
          value: "usdz",
          valueMax: "",
          max: "2048",
          size: "",
          checked: false,
          list: false,
        },
      ],

      compressed: true,
      gltfDown: false,
      glbDown: false,
      usdDown: false,
      usdzDown: false,

      fullscreen: false,

      file2: {
        filename: "shamsail",
        type: "Glb",
        state: "Live",
        tags: "priority",
      },
      file: "",
      fileItems: [],

      exportitems: [
        {
          icon: "mdi-box-shadow",
          title: "shadowIntensity",
          value: "",
          max: "2048",
        },
        {
          icon: "mdi-blender-software",
          title: "shadowSoftness",
          value: "",
          max: "2048",
        },
      ],

      originalGLBfile: true,

      downloadGLB: false,
      downloadGLTF: false,
      downloadUSDZ: false,
      sizeDownloadGLB: "",
      sizeDownloadGLTF: "",
      sizes: false,

      baseUrl: "",

      //hdr Settings
      //start viewer settings datadownload
      hdrSettings: false,
      glbRotation: false,
      glbAnimation: false,
      transparency: false,
      metalness: false,
      occlusion: false,

      lightbutton: true,
      mediabutton: false,
      circlebutton: false,
      spanbtncard: false,
      boxbtncard: false,
      colorbtncard: false,
      filebtncard: false,
      photobtncard: false,
      items: ["Foo", "Bar", "Fizz", "Buzz"],
      spanbtns: [
        { name: "Normals" },
        { name: "Albedo" },
        { name: "Reflectivity" },
        { name: "Gloss" },
        { name: "Typography" },
        { name: "Textured" },
      ],

      itemscolor: [
        { color: "yellow" },
        { color: "blue" },
        { color: "red" },
        { color: "pink" },
        { color: "orange" },
        { color: "grey" },
      ],

      //  filebtns1:[
      //       {title:"ORIGINAL FILE",checked:false,},
      //       ],
      hdrFile: "",
      hdrFileName: "",
      dialog: "",

      //end viewer settings data

      //viewer settings

      //rotation speed and direction
      speedAndDirectionOfModel: "20",
      skipWatchOfSD: false,
      directionClockWise: true,
      speedDirection: "",
      //rotation speed and direction

      //animation
      animationLoop: false,
      animationList: [],
      selectedAnimationList: [],
      playSelectedAnimationList: [],
      animationInterval: "",
      animationSelect: "",
      animationCombined: false,
      animationSelect2nd: "",
      //animation

      //animationAnimationSettings
      animationAnimationSettings: false,
      animationAnimationControls: false,
      animationBlendAnimations: false,
      glbAnimationButton: false,
      animationLoopButton: false,

      //shadow settings
      shadowIntensity: "0.0",
      shadowSoftness: "0.0",
      computedShadowIntensity: "0.0",
      computedShadowSoftness: "0.0",
      //shadow settings

      //HDR settings
      hdrExposure: "1",
      asSkybox: false,
      neutralLight: true,
      //HDR setttings

      //viewer settings
      //hdr Settings
    };
  },
  computed: {
    ...mapState(["augmentableTheme"]),
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    computedDownloadFileItems() {
      var result = this.downloadFileItems.filter((item) => item.list === true);

      return result;
    },

    localtags() {
      const search = this.searchTag.toLowerCase();

      if (!search) return store.state.tags;

      return store.state.tags.filter((item) => {
        const text = item.title.toLowerCase();

        return text.indexOf(search) > -1;
      });
    },

    animationList2nd() {
      var result = this.animationList.filter(
        (item) => item !== this.animationSelect
      );
      return result;
    },
    computedSelectedAnimationList() {
      var result = this.animationList.filter(
        (item) => !this.selectedAnimationList.includes(item)
      );
      return result;
    },
  },
  mounted() {
    this.getGlbFileFromSlug(this.slug);

    //this.file = store.state.fileDetail;
    // console.log(this.file);
    // console.log("gkjgkjgkjhgkjg");

    // alert(this.file.fileusdz);

    //this.changeVersionView(this.file);
    //this.updateStatus(this.file.state);

    //mount animation
    let viewer = new ModelViewerElement();
    viewer = document.getElementById("loading-demo-sub");
    viewer.addEventListener("load", () => {
      this.animationList = viewer.availableAnimations;
      this.animationSelect = this.animationList[0];

      if (!this.file.updatedThumbnail) {
        this.thumbnailGenerate();
      }
    });
    //mount animation

    //upload new version
    document.querySelectorAll(".drop-zone__input").forEach((inputElement) => {
      const dropZoneElement = inputElement.closest(".drop-zone");
      dropZoneElement.addEventListener("dragover", (e) => {
        e.preventDefault();
        //dropZoneElement.classList.add("drop-zone--over");
      });
      ["dragleave", "dragend"].forEach((type) => {
        dropZoneElement.addEventListener(type, (e) => {
          console.log(e);
          //dropZoneElement.classList.remove("drop-zone--over");
        });
      });
      dropZoneElement.addEventListener("drop", (e) => {
        e.preventDefault();
        if (e.dataTransfer.files.length) {
          inputElement.files = e.dataTransfer.files;
          this.goToAddVersionWithFile(e.dataTransfer.files[0]);
          //this.updateThumbnail(dropZoneElement, e.dataTransfer.files[0]);
        }

        //dropZoneElement.classList.remove("drop-zone--over");
      });
    });
    //upload new version

    //this.getAllVersions(this.file.filename);

    //this needs to be chane for online/offline
    var getUrl = window.location;
    //var baseUrl = getUrl .protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
    this.baseUrl = getUrl.protocol + "//" + getUrl.host;

    //this.shareLink = "" + this.baseUrl + "/sharefile/" + this.file.slug;
    this.shareLink = "" + this.baseUrl + "/sharefile/" + this.slug;

    // for password
    axios
      .get(
        this.$abServerPath +
          "/api/glbfiles/augmentable/sharefile/" +
          this.slug +
          "/"
      )
      .then((response) => {
        this.filePassword = response.data.passwordShareFile;
      })
      .catch((error) => {
        console.log(error);
        //this.errored = true;
      });
    // for password

    /*
    let viewer = new ModelViewerElement();
    viewer = document.getElementById("loading-demo-sub");
    if (viewer) {
      console.log("gjghjhg");
    }
    viewer.addEventListener("camera-change", async function () {
      let options = {
        binary: true,
        trs: true,
        onlyVisible: true,
        maxTextureSize: 1024,
        //maxTextureSize: sizeTexture,
        forcePowerOfTwoTextures: true,
        includeCustomExtensions: false,
        embedImages: true,
      };
      let options1 = {
        binary: false,
        trs: true,
        onlyVisible: true,
        maxTextureSize: 1024,
        //maxTextureSize: sizeTexture,
        forcePowerOfTwoTextures: true,
        includeCustomExtensions: false,
        embedImages: true,
      };

      console.log("jhg");
      if (viewer) {
        const glTF = await viewer.exportScene(options);
        var file = new File([glTF], "export.glb");

        const glTF1 = await viewer.exportScene(options1);
        var file1 = new File([glTF1], "export.gltf");

        this.downloadGLB = "" + (file.size / (1024 * 1024)).toFixed(2) + "MB";

        this.downloadGLTF = "" + (file1.size / (1024 * 1024)).toFixed(2) + "MB";
      }
      //this.modelDownload1(true);
      //this.modelDownload1(false);

      viewer.removeEventListener("camera-change");
    });
    */

    if (this.augmentableTheme === true) {
      this.darkTheme = true;
    } else {
      this.lightTheme = true;
    }
  },
  watch: {
    augmentableTheme: function (val) {
      if (val === true) {
        this.lightTheme = false;
        this.darkTheme = true;
      } else {
        this.lightTheme = true;
        this.darkTheme = false;
      }
    },
    downloadGLB: async function (val) {
      let options = {
        binary: true,
        trs: true,
        onlyVisible: true,
        maxTextureSize: 1024,
        //maxTextureSize: sizeTexture,
        forcePowerOfTwoTextures: true,
        includeCustomExtensions: false,
        embedImages: true,
      };

      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");

      if (viewer) {
        if (val === true) {
          const glTF = await viewer.exportScene(options);
          var file = new File([glTF], "export.glb");

          //const glTF1 = await viewer.exportScene(options1);
          //var file1 = new File([glTF1], "export.gltf");

          this.sizeDownloadGLB =
            "" + (file.size / (1024 * 1024)).toFixed(2) + "MB";

          //this.downloadGLTF = "" + (file1.size / (1024 * 1024)).toFixed(2) + "MB";
        } else {
          this.sizeDownloadGLB = "";
        }
      }
    },
    downloadGLTF: async function (val) {
      let options = {
        binary: false,
        trs: true,
        onlyVisible: true,
        maxTextureSize: 1024,
        //maxTextureSize: sizeTexture,
        forcePowerOfTwoTextures: true,
        includeCustomExtensions: false,
        embedImages: true,
      };

      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");

      if (viewer) {
        if (val === true) {
          //const glTF = await viewer.exportScene(options);
          //var file = new File([glTF], "export.glb");

          const glTF1 = await viewer.exportScene(options);
          var file1 = new File([glTF1], "export.gltf");

          //this.sizeDownloadGLB =
          // "" + (file.size / (1024 * 1024)).toFixed(2) + "MB";

          this.sizeDownloadGLTF =
            "" + (file1.size / (1024 * 1024)).toFixed(2) + "MB";
        } else {
          this.sizeDownloadGLTF = "";
        }
      }
    },

    //hdr settings
    directionClockWise: function (val) {
      if (val === true) {
        this.speedDirection = "";
        this.speedAndDirectionOfModel = (
          parseInt(this.speedAndDirectionOfModel) +
          1 -
          1
        ).toString();
      } else {
        this.speedDirection = "-";
        this.speedAndDirectionOfModel = (
          parseInt(this.speedAndDirectionOfModel) +
          1 -
          1
        ).toString();
      }
    },
    speedAndDirectionOfModel: function (val) {
      if (this.skipWatchOfSD === false) {
        this.skipWatchOfSD = true;
        return;
      }
      if (this.glbRotation === false) {
        this.glbRotation = true;
      }

      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");
      if (viewer) {
        viewer["rotationPerSecond"] = this.speedDirection + val + "deg";
      }
    },
    glbRotation: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");
      if (viewer) {
        if (val === true) {
          //viewer["rotationPerSecond"] = this.speedAndDirectionOfModel + "deg";
          viewer["autoRotateDelay"] = 200;
          viewer["autoRotate"] = true;
        } else {
          viewer["autoRotate"] = false;
        }
      }
    },

    glbAnimation: function (val) {
      let modelViewer = new ModelViewerElement();
      modelViewer = document.getElementById("loading-demo-sub");

      if (this.animationCombined === false) {
        modelViewer["animationName"] = this.animationSelect;
        if (val === true && !this.animationLoop) {
          if (this.selectedAnimationList.length !== 0) {
            this.glbAnimationButton = true;
            this.playSelectedAnimations(
              modelViewer,
              this.selectedAnimationList.slice(0),
              false
            );
          } else {
            modelViewer.play();
            this.glbAnimationButton = true;
            setTimeout(
              async function () {
                this.glbAnimation = false;
              }.bind(this),
              modelViewer.duration * 1000
            );
          }
        } else if (val === true && this.animationLoop) {
          if (this.selectedAnimationList.length !== 0) {
            this.glbAnimationButton = true;
            this.playSelectedAnimations(
              modelViewer,
              this.selectedAnimationList.slice(0),
              true
            );
          } else {
            modelViewer.play();
            this.glbAnimationButton = true;
          }
        } else if (val === false) {
          modelViewer.pause();
          this.glbAnimationButton = false;
        }
      } else {
        if (val === true) {
          this.glbAnimationButton = true;
          modelViewer.play();
          const interval2 = setInterval(
            async function () {
              modelViewer.animationName =
                modelViewer.animationName === this.animationSelect
                  ? this.animationSelect2nd
                  : this.animationSelect;

              if (this.animationCombined === false) {
                this.glbAnimationButton = false;
                modelViewer.pause();
                clearInterval(interval2);
              }
            }.bind(this),
            modelViewer.duration * 1000
          );
        }
      }
    },
    animationLoop: async function (val) {
      if (val === true) {
        this.animationLoopButton = true;
        this.glbAnimation = false;
        await this.sleep(1);
        this.glbAnimation = true;
        //console.log(this.glbAnimation);
      } else {
        this.animationLoopButton = false;
        this.glbAnimation = !this.glbAnimation;
        await this.sleep(1);
        this.glbAnimation = !this.glbAnimation;
      }
    },

    asSkybox: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");
      if (viewer) {
        if (val === true) {
          // viewer.setAttribute("environment-image", this.hdrItem);
          viewer.setAttribute("skybox-image", this.hdrItem);
        } else {
          //viewer.removeAttribute("environment-image");
          viewer.removeAttribute("skybox-image");
        }
      }
    },

    neutralLight: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");
      if (viewer) {
        if (val === true) {
          viewer.setAttribute("environment-image", "neutral");
        } else {
          viewer.setAttribute("environment-image", "");
        }
      }
    },

    hdrExposure: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");
      viewer["exposure"] = parseFloat(val);
    },
    shadowIntensity: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");
      viewer["shadowIntensity"] = parseFloat(val);
      this.computedShadowIntensity = val.toFixed(1);
    },
    shadowSoftness: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");
      viewer["shadowSoftness"] = parseFloat(val);
      this.computedShadowSoftness = val.toFixed(1);
    },
    //hdr settings
  },
  methods: {
    getGlbFileFromSlug(slug) {
      axios
        .get(
          this.$abServerPath +
            "/api/glbfiles/augmentable/sharefile/" +
            slug +
            "/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          var item = {
            id: "",
            slug: "",
            password: "",
            filename: "",
            filetype: "",
            fileglb: "",
            filepng: "",
            filesize: "",
            created_at: "",
            updated_at: "",
            tags: "",
            state: "",
            description: "",
            version: "",
            fileusdz: "",
            password_required: "",
            updatedThumbnail: false,
            fileConfig: "",

            //extra
            active: "",
            //extra
          };

          item = response.data;
          item.id = response.data.id;
          item.slug = response.data.slug;
          item.filename = response.data.filename;
          item.filetype = response.data.filetype;
          item.fileglb = this.$abServerPath + "" + response.data.fileglb;
          item.filepng = this.$abServerPath + "" + response.data.filepng;
          item.fileusdz = this.$abServerPath + "" + response.data.fileusdz;
          item.filesize = response.data.filesize;
          item.created_at = this.dateFormat(response.data.created_at);
          item.updated_at = response.data.updated_at;
          if (response.data.tags.charAt(0) === "[") {
            //for new tag objects
            item.tags = JSON.parse(response.data.tags);
          } else {
            //for previous tags when they were string not objects
            var obj = {
              title: "",
              color: "",
            };
            obj.title = response.data.tags;
            obj.color = "#ADD8E6";
            item.tags = [];
            //added lately
            if (obj.title !== "") {
              item.tags.push(obj);
            }
            //added lately

            //item.tags.push(obj);
          }
          item.state = response.data.state;
          this.updateStatus(item.state);
          item.description = response.data.description;
          item.version = response.data.version;

          item.password = response.data.passwordShareFile;
          item.password_required = response.data.password_required;
          item.updatedThumbnail = response.data.updatedThumbnail;

          if (response.data.fileConfig) {
            item.fileConfig = JSON.parse(response.data.fileConfig);
          } else {
            item.fileConfig = "";
          }

          item.active = true;

          this.file = item;

          this.getAllVersions(item.filename);

          // console.log(this.file);
          // console.log("gggg");
          // this.changeVersionView(item);
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
    },
    getAllVersions(filename) {
      axios
        .get(
          this.$abServerPath +
            "/api/glbfiles/glbgetfileversions/" +
            filename +
            "/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          var i;
          var len;

          var item = {
            id: "",
            slug: "",
            password: "",
            filename: "",
            filetype: "",
            fileglb: "",
            filepng: "",
            filesize: "",
            created_at: "",
            updated_at: "",
            tags: "",
            state: "",
            description: "",
            version: "",
            fileusdz: "",
            password_required: "",
            updatedThumbnail: false,
            fileConfig: "",

            //extra
            active: "",
            //extra
          };

          for (i = 0, len = response.data.length; i < len; i++) {
            item = response.data[i];
            item.id = response.data[i].id;
            item.slug = response.data[i].slug;
            item.filename = response.data[i].filename;
            item.filetype = response.data[i].filetype;
            item.fileglb = this.$abServerPath + "" + response.data[i].fileglb;
            item.filepng = this.$abServerPath + "" + response.data[i].filepng;
            item.fileusdz = this.$abServerPath + "" + response.data[i].fileusdz;
            item.filesize = response.data[i].filesize;
            item.created_at = this.dateFormat(response.data[i].created_at);
            item.updated_at = response.data[i].updated_at;
            if (response.data[i].tags.charAt(0) === "[") {
              //for new tag objects
              item.tags = JSON.parse(response.data[i].tags);
            } else {
              //for previous tags when they were string not objects
              var obj = {
                title: "",
                color: "",
              };
              obj.title = response.data[i].tags;
              obj.color = "#ADD8E6";
              item.tags = [];
              //added lately
              if (obj.title !== "") {
                item.tags.push(obj);
              }
              //added lately

              //item.tags.push(obj);
            }
            item.state = response.data[i].state;
            this.updateStatus(item.state);
            item.description = response.data[i].description;
            item.version = response.data[i].version;

            item.password = response.data[i].passwordShareFile;
            item.password_required = response.data[i].password_required;
            item.updatedThumbnail = response.data[i].updatedThumbnail;

            if (response.data[i].fileConfig) {
              item.fileConfig = JSON.parse(response.data[i].fileConfig);
            } else {
              item.fileConfig = "";
            }

            //extra
            // if (i === 0) {
            //   item.active = true;
            // } else {
            //   item.active = false;
            // }
            if (item.version === this.file.version) {
              item.active = true;
              this.changeVersionView(item);
            } else {
              item.active = false;
            }
            //extra

            this.fileItems.push(item);
          }
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
    },
    setCustomObject(object, viewer, fScene) {
      const FAKE_JSON =
        '{"asset":{"version":"2.0"},"scenes":[{"name":"Scene"}],"scene":0}';
      let FAKE_SCENE = URL.createObjectURL(
        new Blob([FAKE_JSON], { type: "application/json" })
      );
      viewer.src = FAKE_SCENE;
      //console.log(viewer);
      fScene.setObject(object);
    },
    async checkAddModelToScene() {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");

      const scene = viewer[Object.getOwnPropertySymbols(viewer)[14]];
      const controls = viewer[Object.getOwnPropertySymbols(viewer)[46]];
      const model = viewer[Object.getOwnPropertySymbols(viewer)[62]];
      console.log(scene);
      console.log(viewer.model);
      console.log(model);
      console.log(controls);
      console.log("jhgjkg");
      // let sceneObj = Object.getOwnPropertySymbols(viewer).find(
      //   (x) => x.description === "scene"
      // );
      console.log(Object.getOwnPropertySymbols(viewer));
      //const scc = viewer[sceneObj];
      // const model1 = scc.children.find((x) => x.name === "ModelContainer");
      // console.log(model1);
      console.log(scene);
      const mesh = scene.children[0];
      console.log(scene.animations);
      console.log(scene.animationsByName["Walk"]);
      console.log(scene.animations[0].blendMode);
      scene.animations[0].blendMode = 10000000;
      console.log(scene.animations[0].blendMode);
      console.log("shamsaiii");
      console.log(mesh);

      // const wireMaterial = new THREE.MeshBasicMaterial({
      //   color: 0xffffff,
      //   wireframe: true,
      // });

      //BufferGeometryUtils.computeTangents(mesh.geometry);

      const clip = THREE.AnimationClip.findByName(scene.animations, "Walk");

      console.log(clip);

      const mixer = new THREE.AnimationMixer(scene);
      console.log(mixer);
      const animationAction = mixer.clipAction(clip);
      console.log(animationAction);
      animationAction.enabled = true;
      animationAction.setEffectiveTimeScale(1);
      animationAction.setEffectiveWeight(1);

      animationAction.reset();
      // animationAction.timeScale = 1;
      // animationAction.setLoop(THREE.LoopOnce);
      // animationAction.clampWhenFinished = true;
      // animationAction.fadeOut(0);
      animationAction.play();
      console.log(animationAction.play());

      //const reader = new FileReader();
      //const readerOBJ = new FileReader();
      //const readerMTL = new FileReader();
      // const DEFAULT_MATERAL = new THREE.MeshStandardMaterial({
      //   color: 0x606060,
      //   roughness: 1.0,
      //   metalness: 0.0,
      // });
      // reader.addEventListener(
      //   "load",
      //   async function (event) {
      //     const object = new OBJLoader().parse(event.target.result);
      //     console.log(object);
      //     object.traverse(function (child) {
      //       const material = child.material;
      //       console.log(material);
      //       if (material && material.isMeshPhongMaterial) {
      //         child.material = DEFAULT_MATERAL;
      //       }
      //     });
      //     let viewer = new ModelViewerElement();
      //     viewer = document.getElementById("loading-demo-sub");
      //     const scene = viewer[Object.getOwnPropertySymbols(viewer)[14]];
      //     this.setCustomObject(object, viewer, scene);
      //   }.bind(this),
      //   false
      // );
      // reader.addEventListener(
      //   "load",
      //   async function (event) {
      //     const object = new FBXLoader().parse(event.target.result);
      //     // object.traverse(function (child) {
      //     //   const material = child.material;
      //     //   if (material && material.isMeshPhongMaterial) {
      //     //     child.material = DEFAULT_MATERAL;
      //     //   }
      //     // });
      //     let viewer = new ModelViewerElement();
      //     viewer = document.getElementById("loading-demo-sub");
      //     const scene = viewer[Object.getOwnPropertySymbols(viewer)[14]];
      //     this.setCustomObject(object, viewer, scene);
      //   }.bind(this),
      //   false
      // );
      // let fillee = await fetch("../assets/obj/H68186_3DFTWRIGHT_hi.fbx")
      //   .then((r) => r.blob())
      //   .then((blobFile) => new File([blobFile], "H68186_3DFTWRIGHT_hi.fbx"));
      // reader.readAsArrayBuffer(fillee);
      // var onProgress = function (xhr) {
      //   if (xhr.lengthComputable) {
      //     var percentComplete = (xhr.loaded / xhr.total) * 100;
      //     console.log(Math.round(percentComplete, 2) + "% downloaded");
      //   }
      // };
      // var onError = function (xhr) {
      //   console.log(xhr);
      // };
      // var mtlLoader = new MTLLoader();
      // var objLoader = new OBJLoader();
      // mtlLoader.setPath("../assets/obj/");
      // mtlLoader.load(
      //   "../assets/obj/FX7729_FTWLEFT.mtl",
      //   function (materials) {
      //     console.log(materials);
      //     console.log("shamsail");
      //     materials.preload();
      //     objLoader.setMaterials(materials);
      //     //objLoader.setPath("../assets/obj/");
      //     objLoader.load(
      //       "../assets/obj/FX7729_FTWLEFT.obj",
      //       function (object) {
      //         let viewer = new ModelViewerElement();
      //         viewer = document.getElementById("loading-demo-sub");
      //         const scene = viewer[Object.getOwnPropertySymbols(viewer)[14]];
      //         this.setCustomObject(object, viewer, scene);
      //       }.bind(this),
      //       onProgress,
      //       onError
      //     );
      //   }.bind(this)
      // );
      // let fillee = await fetch("../assets/obj/FX7729_FTWLEFT.obj")
      //   .then((r) => r.blob())
      //   .then((blobFile) => new File([blobFile], "FX7729_FTWLEFT.obj"));
      // let filleeMTL = await fetch("../assets/obj/FX7729_FTWLEFT.mtl")
      //   .then((r) => r.blob())
      //   .then((blobFile) => new File([blobFile], "FX7729_FTWLEFT.mtl"));
      // //console.log(fillee);
      // console.log(filleeMTL);
      // //reader.readAsText(fillee);
      // readerMTL.readAsText(filleeMTL);
      // readerMTL.addEventListener(
      //   "load",
      //   async function (event) {
      //     const materials1 = new MTLLoader().parse(event.target.result);
      //     console.log(materials1);
      //     console.log("shamsail");
      //     materials1.preload();
      //     let filleeOBJ = await fetch("../assets/obj/FX7729_FTWLEFT.obj")
      //       .then((r) => r.blob())
      //       .then((blobFile) => new File([blobFile], "FX7729_FTWLEFT.obj"));
      //     console.log(filleeOBJ);
      //     readerOBJ.readAsText(filleeOBJ);
      //     readerOBJ.addEventListener(
      //       "load",
      //       async function (event) {
      //         const object = new OBJLoader().parse(event.target.result);
      //         console.log(object);
      //         console.log("shamsii");
      //         object.traverse(async function (child) {
      //           const material = child.material;
      //           console.log(material);
      //           console.log("shaa");
      //           console.log(materials1);
      //           //child.material = materials1;
      //           // if (material && material.isMeshPhongMaterial) {
      //           //   child.material = DEFAULT_MATERAL;
      //           // }
      //         });
      //         let viewer = new ModelViewerElement();
      //         viewer = document.getElementById("loading-demo-sub");
      //         const scene = viewer[Object.getOwnPropertySymbols(viewer)[14]];
      //         this.setCustomObject(object, viewer, scene);
      //       }.bind(this),
      //       false
      //     );
      //   }.bind(this),
      //   false
      // );
      // let viewer = new ModelViewerElement();
      // viewer = document.getElementById("loading-demo-sub");
      // const scene = viewer[Object.getOwnPropertySymbols(viewer)[14]];
      // console.log(scene);
      // let loader = new GLTFLoader();
      // loader.load("../assets/images/export.gltf", function (gltf) {
      //   console.log(gltf);
      //   console.log(gltf.scene);
      //   console.log(gltf.scene.children[0]);
      //   console.log(gltf.scene.children[0].geometry);
      //   //viewer.src = gltf.scene;
      // });
    },
    // createScene(){
    //   let scene,camera,renderer;

    //   scene = new THREE.Scene();
    //   scene.background = new THREE.Color(0xdddddd);

    //   camera = new THREE.PerspectiveCamera(40,window.innerWidth/window.innerHeight,1,5000);

    //   hlight = new THREE.AmbientLight(0x404040,100);
    //   scene.add(hlight);

    //   renderer = new THREE.WebGLRenderer({antialias:true});
    //   renderer.setSize(window.innerWidth,window.innerHeight);
    //   document.body.appendChild(renderer.domElement);
    // },

    selectviewerfile(x) {
      var i;
      var len;
      for (i = 0, len = this.filebtns.length; i < len; i++) {
        if (x === i) {
          this.filebtns[i].checked = true;
        } else {
          this.filebtns[i].checked = false;
        }
      }

      for (i = 2, len = this.downloadFileItems.length; i <= len; i++) {
        if (x + 1 === i) {
          this.downloadFileItems[i].list = true;
        } else {
          this.downloadFileItems[i].list = false;
        }
      }

      // // starting from 2 because 0,1 we have original and optimized
      // for (i=2,len=this.downloadFileItems.length;i<len;i++){
      //   if(this.downloadFileItems[i].value==="draco"){
      //     this.downloadFileItems[i].list = true;
      //   }
      //   else if(this.downloadFileItems[i].value==="glb"){
      //     this.downloadFileItems[i].list = true;
      //   }
      //   else if(this.downloadFileItems[i].value==="gltf"){

      //   }
      //   else if(this.downloadFileItems[i].value==="glb"){

      //   }
      //   else if(this.downloadFileItems[i].value==="usd"){

      //   }
      //   else if(this.downloadFileItems[i].value==="usdz"){

      //   }
      // }

      //this.downloadFileItems[index].list = this.filebtns[index].checked;
    },
    minquality(y) {
      if (y.value > 0) {
        y.value = y.value - 1;
        var index = this.quality.findIndex((x) => x.title === y.title);
        this.quality[index].value = y.value;
      }
    },
    maxquality(y) {
      if (y.value < 10) {
        y.value = y.value + 1;
        var index = this.quality.findIndex((x) => x.title === y.title);
        this.quality[index].value = y.value;
      }
    },
    checkQualityValues(item) {
      var index = this.quality.findIndex((x) => x.title === item.title);
      var i;
      var len;
      for (i = 0, len = this.quality.length; i < len; i++) {
        if (index === i) {
          this.quality[i].checked = true;
        } else {
          this.quality[i].checked = false;
        }
        this.compressionSetting.title = this.quality[index].title;
        this.compressionSetting.value = this.quality[index].value;
      }
    },
    checkFilePassword() {
      axios
        .get(
          this.$abServerPath +
            "/api/glbfiles/augmentable/sharefile/" +
            this.file.slug +
            "/"
        )
        .then((response) => {
          this.filePassword = response.data.passwordShareFile;
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
    },
    unlockOrLockFile() {
      let formData = new FormData();
      if (this.file.password_required === true) {
        formData.append("password_required", "False");
      } else {
        formData.append("password_required", "True");
      }

      axios
        .put(
          this.$abServerPath +
            "/api/glbfiles/glbputHDRfile/" +
            this.file.id +
            "/",
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.updateFileData();
          console.log("SUCCESS!!");
        })
        .catch((error) => {
          this.updateFileData();
          console.log("FAILURE!!");
          console.log(error);
        });
    },
    updateFileData() {
      console.log("ffhfh");
      axios
        .get(
          this.$abServerPath + "/api/glbfiles/glbgetfile/" + this.file.id + "/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          this.file.password_required = response.data.password_required;
          //this.updateStatus(this.file.status);
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
    },
    getShareLink() {
      return this.shareLink;
    },
    newlineDescription() {
      this.file.description = `${this.file.description}\n`;
    },
    inputFileClick() {
      console.log("gjhfgjhf");
      document.getElementById("rr1").click();
    },

    getStateColor(state) {
      if (state === "inProgress") return "light-blue";
      else if (state === "onHold") return "red";
      else if (state === "complete") return "green";
      else if (state === "inQueue") return "orange";
      else return "green";
    },

    getTagsColor(tags) {
      if (tags === "priority") return "red";
      else if (tags === "urgent") return "light-blue";
      else if (tags === "share") return "green";
      else if (tags === "fix") return "orange";
      else return "green";
    },
    saveQrCode() {
      // htmlToImage
      //   .toJpeg(document.getElementById("qrCode"), { quality: 0.95 })
      //   .then(function (dataUrl) {
      //     var link = document.createElement("a");
      //     link.download = "qrcode.jpeg";
      //     link.href = dataUrl;
      //     link.click();
      //   });

      htmlToImage
        .toBlob(document.getElementById("qrCode"))
        .then(function (blob) {
          saveAs(blob, "qrcode.png");
        });
    },

    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    toggleFullScreen() {
      this.$refs["fullscreen"].toggle(); // recommended
      // this.fullscreen = !this.fullscreen // deprecated
    },

    goBackToFiles() {
      this.$router.push({ path: "/assets" });
    },

    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;

      if (this.fullscreen == true) {
        console.log(this.fullscreen);
        document.getElementById("loading-demo-sub").style.minHeight = "100vh";
        document.getElementById("loading-demo-sub").style.borderRadius = "0";
      } else {
        document.getElementById("loading-demo-sub").style.minHeight = "50vh";
        document.getElementById("loading-demo-sub").style.borderRadius = "50px";
        console.log(this.fullscreen);
      }
    },

    selectedAnimationListFunc(item) {
      this.selectedAnimationList.push(item);
    },
    removeSelectedAnimationList(index) {
      this.selectedAnimationList.splice(index, 1);
    },
    playSelectedAnimations(viewer, animationList, loop) {
      if (loop) {
        clearInterval(this.animationInterval);

        viewer["animationName"] = animationList.shift();
        //for loop
        if (this.animationLoop) {
          animationList.push(viewer["animationName"]);
        }
        //for loop
        viewer.play();

        // if(!this.glbAnimation){
        //   animationList
        // }
        if (animationList.length == 0) {
          setTimeout(
            function () {
              viewer.pause();
              this.glbAnimation = false;
              this.glbAnimationButton = false;
            }.bind(this),
            viewer.duration * 1000
          );
          //clearInterval(this.animationInterval);
        } else {
          this.animationInterval = setInterval(
            this.playSelectedAnimations,
            viewer.duration * 1000,
            viewer,
            animationList,
            loop
          );
        }
      } else {
        if (this.animationInterval) {
          clearInterval(this.animationInterval);
        }

        viewer["animationName"] = animationList.shift();
        viewer.play();

        if (animationList.length == 0) {
          setTimeout(
            function () {
              viewer.pause();
              this.glbAnimation = false;
              this.glbAnimationButton = false;
            }.bind(this),
            viewer.duration * 1000
          );
          //clearInterval(this.animationInterval);
        } else {
          this.animationInterval = setInterval(
            this.playSelectedAnimations,
            viewer.duration * 1000,
            viewer,
            animationList,
            loop
          );
        }
      }
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    playNextAnimation() {
      let animationPCN = this.findAnimationIndex();
      console.log(animationPCN[0] + "  " + animationPCN[1]);
      this.animationSelect = animationPCN[2];
      this.animationSelected(animationPCN[2]);
    },
    playPreviousAnimation() {
      let animationPCN = this.findAnimationIndex();
      console.log(animationPCN[1] + "  " + animationPCN[2]);
      this.animationSelect = animationPCN[0];
      this.animationSelected(animationPCN[0]);
    },
    findAnimationIndex() {
      var index = this.animationList.findIndex(
        (x) => x === this.animationSelect
      );
      var lastIndex = this.animationList.length - 1;

      var previousAnimationName = "";
      var nextAnimationName = "";

      let checkNext = lastIndex - index;
      let checkPrevious = index - 0;
      if (checkNext > 0) {
        nextAnimationName = this.animationList[index + 1];
      } else {
        nextAnimationName = this.animationList[0];
      }
      if (checkPrevious > 0) {
        previousAnimationName = this.animationList[index - 1];
      } else {
        previousAnimationName = this.animationList[lastIndex];
      }

      return [previousAnimationName, this.animationSelect, nextAnimationName];
    },
    async animationSelected(x) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");
      if (viewer) {
        viewer["animationName"] = x;
        this.glbAnimation = false;
        await this.sleep(1);
        this.glbAnimation = true;
      }
    },
    async insertOtherAnimationSelected(x) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");
      if (viewer) {
        viewer["animationName"] = x;
        this.animationCombined = false;
        this.glbAnimation = false;
        await this.sleep(1);
        this.animationCombined = true;
        // this.animationLoop = true;
        this.glbAnimation = true;
      }
    },

    sliderEvent() {
      console.log("clicked and checked");
    },
    sliderEvent1(x, y) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");
      if (viewer) {
        console.log(x, y);
        viewer[x] = parseFloat(y);
      }
    },
    glbRotationFunc() {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");
      if (viewer) {
        if (this.glbRotation === true) {
          console.log(this.glbRotation);
          viewer["autoRotate"] = true;
        } else {
          console.log(this.glbRotation);
          viewer["autoRotate"] = false;
        }
      }
    },

    async modelDownload(binary) {
      let options = {
        binary: binary,
        trs: true,
        onlyVisible: true,
        maxTextureSize: 1024,
        //maxTextureSize: sizeTexture,
        forcePowerOfTwoTextures: true,
        includeCustomExtensions: false,
        embedImages: true,
      };
      console.log("download");
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");
      if (viewer) {
        const glTF = await viewer.exportScene(options);
        var file = new File([glTF], binary ? "export.glb" : "export.gltf");
        var link = document.createElement("a");
        link.download = file.name;
        link.href = URL.createObjectURL(file);
        link.click();
      }
    },
    async modelDownload1(binary) {
      let options = {
        binary: binary,
        trs: true,
        onlyVisible: true,
        maxTextureSize: 1024,
        //maxTextureSize: sizeTexture,
        forcePowerOfTwoTextures: true,
        includeCustomExtensions: false,
        embedImages: true,
      };
      console.log("download");
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");

      console.log("jhg");
      if (viewer) {
        const glTF = await viewer.exportScene(options);
        var nameDownloadFileGLB =
          this.file.filename + "_V" + this.file.version + ".glb";
        var nameDownloadFileGLTF =
          this.file.filename + "_V" + this.file.version + ".gltf";
        //var file = new File([glTF], binary ? "export.glb" : "export.gltf");
        var file = new File(
          [glTF],
          binary ? nameDownloadFileGLB : nameDownloadFileGLTF
        );

        if (binary) {
          this.downloadGLB = "" + (file.size / (1024 * 1024)).toFixed(2) + "MB";
        } else {
          this.downloadGLTF =
            "" + (file.size / (1024 * 1024)).toFixed(2) + "MB";
        }

        return file.size;
      }
    },
    // sizeDownloadGLB() {
    //   this.modelDownload1(true);
    // },
    // sizeDownloadGLTF() {
    //   this.modelDownload1(false);
    // },
    downloadFiles() {
      /*
      var len;
      var i;

      len = this.downloadFileItems.length - 1;
      for (i = len; i >= 0; i--) {
        if (
          this.downloadFileItems[i]["title"] === "Original GLB File" &&
          this.downloadFileItems[i]["value"] === true
        ) {
          console.log("original glb file");

          let viewer = new ModelViewerElement();
          viewer = document.getElementById("loading-demo-sub");

          if (viewer) {
            var link = document.createElement("a");
            //link.download = this.fileName;
            link.download = "Original";
            link.href = viewer.src;
            link.click();
          }
        }
        if (
          this.downloadFileItems[i]["title"] === "GLB File" &&
          this.downloadFileItems[i]["value"] === true
        ) {
          console.log("glb file");

          this.modelDownload(true, this.downloadFileItems[i]["valueMax"]);
        }
        if (
          this.downloadFileItems[i]["title"] === "GLTF File" &&
          this.downloadFileItems[i]["value"] === true
        ) {
          console.log("GLTF File");
          this.modelDownload(false, this.downloadFileItems[i]["valueMax"]);
        }
        if (
          this.downloadFileItems[i]["title"] === "USDZ File" &&
          this.downloadFileItems[i]["value"] === true
        ) {
          console.log("USDZ File");
        }
      }
      */

      if (this.originalGLBfile === true) {
        console.log("original glb file");

        let viewer = new ModelViewerElement();
        viewer = document.getElementById("loading-demo-sub");

        if (viewer) {
          var link = document.createElement("a");
          link.download =
            this.file.filename + "_V" + this.file.version + ".glb";
          //alert(link.download);
          //alert(this.file.version);
          link.href = viewer.src;
          link.click();
        }
      }
      if (this.downloadGLB === true) {
        console.log("glb file");

        this.modelDownload(true);
      }
      if (this.downloadGLTF === true) {
        console.log("GLTF File");
        this.modelDownload(false);
      }

      if (this.downloadUSDZ === true) {
        console.log("USDZ File");
        if (this.file.fileusdz === "") {
          console.log("empty");
        } else {
          var downloadName1 =
            this.file.filename + "_V" + this.file.version + ".usdz";
          var link1 = document.createElement("a");
          link1.download = downloadName1;
          link1.href = this.file.fileusdz;
          link1.click();
        }
      }
    },

    dateFormat(x) {
      return (
        "" + x.slice(8, 10) + "." + x.slice(5, 7) + "." + x.slice(0, 4) + ""
      );
    },
    formatVersion(n) {
      return n > 9 ? "" + n : "0" + n;
    },
    changeVersionView(fileVersion) {
      this.filePassword = fileVersion.passwordShareFile;
      this.$store.commit("setFileDetail", fileVersion);

      this.file = fileVersion;
      this.file.id = fileVersion.id;
      this.file.slug = fileVersion.slug;
      this.file.filename = fileVersion.filename;
      this.file.filetype = fileVersion.filetype;
      this.file.fileglb = fileVersion.fileglb;
      this.file.filepng = fileVersion.filepng;
      this.file.filesize = fileVersion.filesize;
      this.file.created_at = fileVersion.created_at;
      this.file.updated_at = fileVersion.updated_at;
      this.file.tags = fileVersion.tags;
      this.file.state = fileVersion.state;
      this.updateStatus(this.file.state);
      this.file.description = fileVersion.description;
      this.file.version = fileVersion.version;
      this.file.fileusdz = fileVersion.fileusdz;

      this.file.password_required = fileVersion.password_required;

      this.file.updatedThumbnail = fileVersion.updatedThumbnail;

      this.file.fileConfig = fileVersion.fileConfig;

      if (this.file.fileConfig) {
        this.neutralLight = this.file.fileConfig["neutralLight"];
        this.hdrExposure = this.file.fileConfig["hdrExposure"];
        this.shadowIntensity = this.file.fileConfig["shadowIntensity"];
        this.shadowSoftness = this.file.fileConfig["shadowSoftness"];
      } else {
        this.neutralLight = true;
        this.hdrExposure = "1";
        this.shadowIntensity = "0.0";
        this.shadowSoftness = "0.0";
      }

      this.shareLink = "" + this.baseUrl + "/sharefile/" + this.file.slug;

      let i;
      let len;
      for (i = 0, len = this.fileItems.length; i < len; i++) {
        if (this.file.version === this.fileItems[i].version) {
          this.fileItems[i].active = true;
        } else {
          this.fileItems[i].active = false;
        }
      }

      //re route on the basis of new version
      let lastSlug = this.$router.currentRoute.path.substring(
        this.$router.currentRoute.path.lastIndexOf("/") + 1
      );

      if (lastSlug === store.state.fileDetail.slug) {
        console.log("");
      } else {
        this.$router.push({
          name: "File Detail",
          params: { slug: store.state.fileDetail.slug },
        });
      }
    },
    deleteFiles(x) {
      var i;
      var len;

      for (i = 0, len = x.length; i < len; i++) {
        this.deleteFile(x[i].id);
      }
      this.$router.push({ path: "/assets" });
    },
    deleteSingleFile(y) {
      //delete file from server
      this.deleteFile(y);

      //delete file on browser DOM
      var index = this.fileItems.findIndex((x) => x.id === y);
      this.fileItems.splice(index, 1);

      //change display on browser DOM with updated file and versions
      var displayVersion = this.fileItems.slice(0);
      this.changeVersionView(displayVersion[0]);
    },
    deleteFile(x) {
      //delete file from server with the given id "x"
      axios
        .delete(this.$abServerPath + "/api/glbfiles/glbdeletefile/" + x + "/", {
          headers: {
            Authorization:
              "Token " + this.getAuthCookie("augmentableUserToken") + "",
          },
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addVersion() {
      this.$router.push({
        name: "Add Version",
        params: { selectedFileVersion: this.file.filename },
      });
    },
    deleteTagFromServer(index) {
      console.log(index);
      this.file.tags.splice(index, 1);
      this.serverTags = JSON.stringify(this.file.tags);
      //delete locally and updating on server
      let formData = new FormData();
      formData.append("tags", this.serverTags);
      axios
        .put(
          this.$abServerPath +
            "/api/glbfiles/glbputupdatefile/" +
            this.file.id +
            "/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response.status);
        })
        .catch((error) => {
          console.log(error.data);
        });
    },
    tagpassToServer(x, y) {
      var obj = {
        title: "",
        color: "",
      };
      obj.title = x;
      obj.color = y;
      this.file.tags.unshift(obj);
      x = "";
      y = "";

      this.serverTags = JSON.stringify(this.file.tags);
      if (this.serverTags.length > 490) {
        this.file.tags.shift();
        this.serverTags = JSON.stringify(this.file.tags);
        alert("you can't add more tags to it");
        return;
      } else {
        let formData = new FormData();
        formData.append("tags", this.serverTags);
        axios
          .put(
            this.$abServerPath +
              "/api/glbfiles/glbputupdatefile/" +
              this.file.id +
              "/",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            console.log(response.status);
            // console.log(response.data);
          })
          .catch((error) => {
            console.log(error.data);
          });
      }
      //console.log(this.serverTags);
      //console.log(JSON.parse(this.serverTags));
    },
    updateStatus(state) {
      var i;
      var len;
      var index = this.localStatus.findIndex((x) => x.title === state);
      for (i = 0, len = this.localStatus.length; i < len; i++) {
        if (i === index) {
          this.localStatus[i].value = true;
        } else {
          this.localStatus[i].value = false;
        }
      }
    },
    editDescription() {
      this.descriptionEdit = true;
      this.description = true;
    },
    updateDescription() {
      let formData = new FormData();
      formData.append("description", this.file.description);
      axios
        .put(
          this.$abServerPath +
            "/api/glbfiles/glbputupdatefile/" +
            this.file.id +
            "/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response.status);
          this.descriptionEdit = false;
        })
        .catch((error) => {
          console.log(error.data);
        });
    },
    changeStatus(item) {
      var i;
      var len;
      var index = this.localStatus.findIndex((x) => x.title === item.title);

      for (i = 0, len = this.localStatus.length; i < len; i++) {
        if (i === index) {
          this.localStatus[i].value = true;
        } else {
          this.localStatus[i].value = false;
        }
      }

      let formData = new FormData();
      formData.append("state", item.title);

      axios
        .put(
          this.$abServerPath +
            "/api/glbfiles/glbputHDRfile/" +
            this.file.id +
            "/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log("success");
          axios
            .get(
              this.$abServerPath +
                "/api/glbfiles/glbgetfile/" +
                this.file.id +
                "/",
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Token " + this.getAuthCookie("augmentableUserToken") + "",
                },
              }
            )
            .then((response) => {
              console.log(response.data.state);
              this.file.state = response.data.state;
              this.updateStatus(this.file.status);
            })
            .catch((error) => {
              console.log(error);
              //this.errored = true;
            });

          console.log(response);
        })
        .catch((error) => {
          axios
            .get(
              this.$abServerPath +
                "/api/glbfiles/glbgetfile/" +
                this.file.id +
                "/",
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Token " + this.getAuthCookie("augmentableUserToken") + "",
                },
              }
            )
            .then((response) => {
              console.log(response.data.state);
              this.file.state = response.data.state;
              this.updateStatus(this.file.state);
            })
            .catch((error) => {
              console.log(error);
              //this.errored = true;
            });

          console.log(error);
        });
    },
    updateFileItems() {
      this.fileItems = [];
      axios
        .get(
          this.$abServerPath +
            "/api/glbfiles/glbgetfileversions/" +
            this.file.filename +
            "/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          console.log(response.data);
          console.log("gjkhgkjh");

          var i;
          var len;

          var item = {
            id: "",
            slug: "",
            filename: "",
            filetype: "",
            fileglb: "",
            filepng: "",
            filesize: "",
            created_at: "",
            updated_at: "",
            tags: "",
            state: "",
            description: "",
            version: "",
            fileusdz: "",
          };

          for (i = 0, len = response.data.length; i < len; i++) {
            item = response.data[i];
            item.id = response.data[i].id;
            item.slug = response.data[i].slug;
            item.filename = response.data[i].filename;
            item.filetype = response.data[i].filetype;
            item.fileglb = this.$abServerPath + "" + response.data[i].fileglb;
            item.filepng = this.$abServerPath + "" + response.data[i].filepng;
            item.fileusdz = this.$abServerPath + "" + response.data[i].fileusdz;
            item.filesize = response.data[i].filesize;
            item.created_at = this.dateFormat(response.data[i].created_at);
            item.updated_at = response.data[i].updated_at;
            if (response.data[i].tags.charAt(0) === "[") {
              //for new tag objects
              item.tags = JSON.parse(response.data[i].tags);
            } else {
              //for previous tags when they were string not objects
              var obj = {
                title: "",
                color: "",
              };
              obj.title = response.data[i].tags;
              obj.color = "#ADD8E6";
              item.tags = [];
              item.tags.push(obj);
            }
            item.state = response.data[i].state;
            this.updateStatus(item.state);
            item.description = response.data[i].description;
            item.version = response.data[i].version;
            item.password_required = response.data[i].password_required;
            this.fileItems.push(item);
          }
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
    },
    // changeScene() {
    //   var inputElement = document.getElementById("rr1");
    //   console.log(inputElement);

    //   const dropZoneElement = inputElement.closest(".drop-zone");

    //   console.log(dropZoneElement);
    //   console.log(inputElement.files[0]);

    //   //this.updateThumbnail(dropZoneElement, inputElement.files[0]);
    // },
    goToAddVersionWithFile(file) {
      var extension11 = file.name.split(".").pop();
      if (extension11 === "glb" || extension11 === "gltf") {
        console.log(file);
        this.$router.push({
          name: "Add Version",
          params: { selectedFileVersion: this.file.filename, file1: file },
        });
      }
    },

    saveFileConfig() {
      let fileConfig = {
        neutralLight: this.neutralLight,
        hdrExposure: this.hdrExposure,
        shadowIntensity: this.shadowIntensity,
        shadowSoftness: this.shadowSoftness,
      };

      let formData = new FormData();
      formData.append("fileConfig", JSON.stringify(fileConfig));
      axios
        .put(
          this.$abServerPath +
            "/api/glbfiles/glbputupdatefile/" +
            this.file.id +
            "/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          this.file.fileconfig = JSON.parse(response.data.fileConfig);
          let i;
          let len;
          for (i = 0, len = this.fileItems.length; i < len; i++) {
            if (this.fileItems[i].active === true) {
              this.fileItems[i].fileConfig = this.file.fileconfig;
            }
          }
        })
        .catch((error) => {
          console.log(error.data);
        });
    },
    //start settings functions
    //   1st btn
    lightf() {
      this.lightbutton = true;
      this.circlebutton = false;
      this.mediabutton = false;
      this.boxbtncard = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
    },

    //   2nd btn
    circlef() {
      this.circlebutton = true;
      this.lightbutton = false;
      this.mediabutton = false;
      this.boxbtncard = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
    },

    //3rd btn
    mediaf() {
      this.mediabutton = true;
      this.lightbutton = false;
      this.circlebutton = false;
      this.boxbtncard = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
    },

    //4th btn
    colorbtnf() {
      this.colorbtncard = true;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.boxbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
    },

    //5th btn
    boxbtnf() {
      this.boxbtncard = true;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
    },
    //6th btn
    filebtnf() {
      this.filebtncard = true;
      this.boxbtncard = false;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.colorbtncard = false;
      this.photobtncard = false;
    },
    //7th btn
    photobtnf() {
      this.photobtncard = true;
      this.filebtncard = false;
      this.boxbtncard = false;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.colorbtncard = false;
    },

    colorf(x) {
      alert(x.color);
    },
    checkExportFiles(item, index) {
      //console.log(item, index);
      this.filebtns[index].checked = !this.filebtns[index].checked;
      this.downloadFileItems[index].list = this.filebtns[index].checked;
      // if (this.filebtns[index].name === "Draco") {
      //   this.compressed = this.filebtns[index].checked;
      // } else if (this.filebtns[index].name === "GLB") {
      //  this.glbDown = this.filebtns[index].checked;
      // } else if (this.filebtns[index].name === "GLTF") {
      //   this.gltfDown = this.filebtns[index].checked;
      // } else if (this.filebtns[index].name === "USD") {
      //   this.usdDown = this.filebtns[index].checked;
      // } else if (this.filebtns[index].name === "USDZ") {
      //   this.usdzDown = this.filebtns[index].checked;
      // }
    },
    //end settings functions
    checkExportValues(item, index) {
      if (this.computedDownloadFileItems[index].value === "original") {
        this.originalGLBfile = this.computedDownloadFileItems[index].checked;
      } else if (this.computedDownloadFileItems[index].value === "draco") {
        this.computedDownloadDraco =
          this.computedDownloadFileItems[index].checked;
      } else if (this.computedDownloadFileItems[index].value === "glb") {
        this.downloadGLB = this.computedDownloadFileItems[index].checked;
      } else if (this.computedDownloadFileItems[index].value === "gltf") {
        this.downloadGLTF = this.computedDownloadFileItems[index].checked;
      } else if (this.computedDownloadFileItems[index].value === "usdz") {
        this.downloadUSDZ = this.computedDownloadFileItems[index].checked;
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      console.log(this.$sidebar.showSidebar);
    },
    goToEditorWithFile() {
      this.$store.commit("setFileDetail", this.file);
      this.$router.push({ path: "/editor" });
    },
    goToViewerWithFile() {
      this.$store.commit("setFileDetail", this.file);
      this.$router.push({ path: "/viewer" });
    },
    async thumbnailGenerate() {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub");
      let posterUrl = "";
      //const a = document.createElement("a");
      const orbit = viewer.getCameraOrbit();

      viewer.fieldOfView = "auto";
      const fov = viewer.getFieldOfView();

      const orbitString = `${orbit.theta}rad ${orbit.phi}rad ${orbit.radius}m`;
      const fovString = `${fov}deg`;
      console.log(orbitString);
      console.log(fovString);

      //orbitString.textContent = `${orbit.theta}rad ${orbit.phi}rad auto`;
      console.log(orbit);
      viewer.fieldOfView = "auto";
      //viewer.jumpCameraToGoal();
      await new Promise((resolve) => requestAnimationFrame(() => resolve()));
      URL.revokeObjectURL(posterUrl);
      const blob = await viewer.toBlob({
        mimeType: "image/png",
        idealAspect: true,
      });
      console.log(blob);
      this.updateThumbnail(blob);
      // var a = document.createElement("a");
      // let url = URL.createObjectURL(blob);
      // a.href = url;
      // a.download = "scc.png";
      // a.click();
      // URL.revokeObjectURL(url);
    },
    updateThumbnail(blob) {
      let formData = new FormData();

      formData.append("updatedThumbnail", "True");
      formData.append("filepng", blob, this.file.filename + ".png");

      axios
        .put(
          this.$abServerPath +
            "/api/glbfiles/glbputHDRfile/" +
            this.file.id +
            "/",
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.updateFileThumbnail();
          console.log("SUCCESS!!");
        })
        .catch((error) => {
          this.updateFileThumbnail();
          console.log("FAILURE!!");
          console.log(error);
        });
    },
    updateFileThumbnail() {
      axios
        .get(
          this.$abServerPath + "/api/glbfiles/glbgetfile/" + this.file.id + "/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          this.file.filepng = this.$abServerPath + "" + response.data.filepng;
          this.file.updatedThumbnail = response.data.updatedThumbnail;
          console.log(this.file.filepng);
          // let i;
          // let len;
          // for (i = 0, len = this.fileItems.length; i < len; i++) {
          //   if (this.fileItems[i].active === true) {
          //     console.log(this.fileItems[i].filepng);
          //     console.log(this.file.filepng);
          //     this.fileItems[i].filepng = this.file.filepng;
          //     console.log(this.fileItems[i].filepng);
          //     console.log(this.file.filepng);
          //   }
          // }
          console.log("rr");
          //this.updateStatus(this.file.status);
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
    },
  },
};
</script>



<style lang="scss" scoped>
@import "../assets/scss/material-dashboard.scss";

.mainARview {
  position: relative;
  background-image: radial-gradient(#808080, #262626);
}

.textARview {
  top: 0;
  left: 0;
  width: 100%;

  text-align: center;
  color: white;
  font-size: 12px;

  cursor: pointer;
  font-family: "Raleway";

  position: absolute;
}

.mainARview1 {
  position: relative;
  background-image: radial-gradient(white, #cccccc);
}

.textARview1 {
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  color: #444444;
  font-size: 12px;

  cursor: pointer;
  font-family: "Raleway";

  position: absolute;
}

.drop-zone {
  width: 100%;

  min-height: 20vh;
  cursor: pointer;
}

.drop-zone--over {
  border-style: solid;
}

.drop-zone__input {
  display: none;
}

.drop-zone__thumb {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100vh;
  min-height: 100vh;
}

.drop-zone__thumb::after {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 0;

  font-size: 14px;
  text-align: center;
}
.drop-zone__prompt {
  font-size: 50px;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}
.scrollClass {
  overflow-x: scroll !important;
}

.scrollClass::-webkit-scrollbar {
  width: 5px;
}

.hdrNavigation {
  top: 0;
  left: 0;
  z-index: 100;
  background-color: transparent;
  position: absolute;
  font-family: "Nunito Sans";
}
.originalnot:hover {
  background-color: #419cff;
  opacity: 0.6;
  height: 2.5em;
  border-radius: 10px;
}
.expand1 {
  overflow-y: auto !important;
  scrollbar-color: #a0a0a0 transparent;
  scrollbar-width: thin;
  overflow-x: hidden;
}

.expand1::-webkit-scrollbar {
  width: 3px;
}

.expand1::-webkit-scrollbar-track {
  background: transparent;
}
.expand1::-webkit-scrollbar-thumb {
  background: #a0a0a0;
  border-radius: 10px;
}
</style>

